import ks, { kObject, kObjectArray, kObjectArrayCore, kTime } from "../ReUsableTS/kalmstromShared4";
import {kSelect, kDateInput} from "../ReUsableTS/kHTML";
import { kHTMLMultiSelect, kMultiSelectOption } from "../ReUsableTS/kHTMLMultiSelect";
import { kContextMenu } from "../ReUsableTS/kContextMenu";
import { kExcelExport } from "../ReUsableTS/kExcelExport";
import LNG from "../ReUsableTS/kLNG";
import { kFluentIcons } from "./kFluentIcons";
import { kStyleClass, kStyles } from "./kStyles";

export class kEditableTableRow extends kObject{
    public ParentTable:kEditableTable|null = null;
    public RowNumberCell:HTMLTableCellElement|null = null;
    public Row: HTMLTableRowElement |null = null;


    public Hidden:boolean = false;
    constructor(Index: number) {
        super();
        if (ks.kErrorMode === true) { return; }
        try {

            this.Row = document.createElement("tr");
            this.Row.className = "kEditableTableRow";
            this.Row.setAttribute("role", "row");
            this.RowNumberCell = document.createElement("td");
            this.RowNumberCell.className = "kRowNumberHeading";
            this.RowNumberCell.setAttribute("role", "rowheader");
            this.RowNumberCell.addEventListener("click", this.RowClick);
            this.RowNumberCell.addEventListener("contextmenu", this.RowRightClick);
            this.RowNumberCell.textContent = (Index +1).toString();
            this.Row.appendChild(this.RowNumberCell);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.constructor");
            return;
        }
    }

    public RowClick = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                kEditableTable.SetActiveTable(this.ParentTable);
                this.ParentTable.Selection.SetSingleRowSelected(this);
                if(this.ParentTable.RowClickCB){
                    this.ParentTable.RowClickCB(this);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.RowClick");
            return;
        }
    }
    public RowRightClick = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                if(this.ParentTable.RowRightClickCB){
                    this.ParentTable.RowRightClickCB(this,Event);
                }else if(this.ParentTable.RowContextMenu){
                    this.ParentTable.RightClickRow = this;
                    this.ParentTable.RowContextMenu.ShowMenu(Event);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.RowRightClick");
            return;
        }
    }

    public Cells: Array<kEditableTableCell> = new Array<kEditableTableCell>();
    public AddCell = (Cell: kEditableTableCell): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Cells.push(Cell);
            if(this.Row){
                this.Row.appendChild(Cell.Cell);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.AddCell");
            return;
        }
    }
    public IsDirty = (): boolean => {
        if (ks.kErrorMode === true) { return false; }
        try {
            let CurrCell:kEditableTableCell;
            for(CurrCell of this.Cells){
                if(CurrCell.Dirty === true){
                    return true;
                }
            }
            return false;   
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.IsDirty");
            return false;
        }
    }
    public SetClean = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrCell:kEditableTableCell;
            for(CurrCell of this.Cells){
                CurrCell.SetClean();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.SetClean");
        }
    }
    public GetValueFromCell = (PropertyName:string): any => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrCell:kEditableTableCell;
            for(CurrCell of this.Cells){
                if(CurrCell.ColDef.kObjectPropertyName === PropertyName){
                    switch (CurrCell.ColDef.Type) {
                        case kHTMLEditableColType.Select:
                            return ks.nz(CurrCell.CurrentValue);
                        case kHTMLEditableColType.Number:
                            return ks.n0(CurrCell.CurrentValue);
                        case kHTMLEditableColType.Currency:
                            return ks.NumberFromCurrency(CurrCell.CurrentValue);
                        case kHTMLEditableColType.SelectMulti:
                            if(CurrCell.CurrentValue){
                                return CurrCell.CurrentValue.split("; ");
                            }else{
                                return [];
                            }
                        default:
                            return CurrCell.CurrentValue;
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.GetValueFromCell");
            return;
        }
    }
    public SetValueToCell = (PropertyName:string,value:any,SetDirty?:boolean): any => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrCell:kEditableTableCell;
            for(CurrCell of this.Cells){
                if(CurrCell.ColDef.kObjectPropertyName === PropertyName){
                    return CurrCell.SetNewValue(value,SetDirty);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.SetValueToCell");
            return;
        }
    }
    public Remove = (CB:any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Row){
                this.Row.remove();
                if(this.ParentTable){
                    this.ParentTable.Rows.RemoveItemByIndex(this.Index);
                }
            }
            if(this.ParentTable){
                if(this.ParentTable.RowDeletedCB){
                    this.ParentTable.RowDeletedCB(this,CB);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.Remove");
        }
    }
    public Hide = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Row){
                this.Row.style.display = "none";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.Hide");
        }
    }
    public Show = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Row){
                this.Row.style.display = "table-row";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.Show");
        }
    }
    public FadeOut = (AfterCB:any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Row){
                this.Row.animate([{ transform: "scale(1)" },{ transform: "scale(0)" }],{duration: 250,iterations: 1});
                window.setTimeout(AfterCB,250);
            }
            this.Hidden = true;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.FadeOut");
        }
    }
    public FadeIn = (AfterCB:any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Row){
                this.Row.animate([{ transform: "scale(0)" },{ transform: "scale(1)" }],{duration: 250,iterations: 1});
                window.setTimeout(AfterCB,250);
            }
            this.Hidden = false;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.FadeIn");
        }
    }
    public RemoveAfterFadeOut = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Row){
                this.Row.remove();
            }
            if(this.ParentTable){
                this.ParentTable.Rows.RemoveItemByUniqueID(this.UniqueID);
                this.ParentTable.UpdateRowNumbers();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.RemoveAfterFadeOut");
        }
    }
    public IsEmpty = (): boolean => {
        let FirstCell:kEditableTableCell;
        if (ks.kErrorMode === true) { return false; }
        try {
            FirstCell = this.Cells[0];
            let CurrValue:any = FirstCell.CurrentValue;
            if(CurrValue === "" ||CurrValue === undefined||CurrValue === null){
                return true;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.IsEmpty");
        }
        return false;
    }

    public SelectLastCell = (): void => {
        let CurrCell:kEditableTableCell;
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                CurrCell = this.Cells[this.Cells.length-1];
                CurrCell.Select();

            }
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.SelectLastCell");
        }
    }
    public SelectFirstCell = (): void => {
        let CurrCell:kEditableTableCell;
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                CurrCell = this.Cells[0];
                CurrCell.Select();

            }
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SelectFirstCell");
        }
    }

    public ReadOnly: boolean = false;
    public SetReadOnly = (ReadOnly: boolean): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.ReadOnly = ReadOnly;
            if (this.Row) {
                if (ReadOnly) {
                    this.Row.classList.add("kEditableTableRowReadOnly");
                } else {
                    this.Row.classList.remove("kEditableTableRowReadOnly");
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow.SetReadOnly");
        }
    }
}
export class kEditableTableRows extends kObjectArray{
    public Items: kEditableTableRow[] = [];
 
}
export class kEditableTableCell extends kObject{
    private static readonly DIRTY_DEBOUNCE_MS: number = 300;

    public _RadioHtml = (On: boolean): string => {
        if (ks.kErrorMode === true) { return ""; }
        try {
            if (On) {
                return `<span style="display:inline-block;width:14px;height:14px;border-radius:50%;border:2px solid #0078d4;background:#0078d4;box-shadow:inset 0 0 0 3px white;box-sizing:border-box;vertical-align:middle"></span>`;
            }
            return `<span style="display:inline-block;width:14px;height:14px;border-radius:50%;border:2px solid #aaa;background:white;box-sizing:border-box;vertical-align:middle"></span>`;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._RadioHtml");
            return "";
        }
    }
    constructor() {
        super();
        this.Cell = document.createElement("td");
        this.Cell.className = "kEditableTableCell";
        this.Cell.setAttribute("role", "gridcell");
        this.Cell.addEventListener("click", this.CellClick);
        this.Cell.addEventListener("contextmenu",this._CellRightClick);
        this.Cell.addEventListener("mouseover",this._MouseOver);
        this.Cell.addEventListener("mousedown", this._MouseDown);
    }
    public SelectionMode:kEdTblSelectionMode = kEdTblSelectionMode.NoSelection;
    public OrgValue:any = null;
    public CurrentValue:any = null;
    public Dirty:boolean = false;

    public Cell: HTMLTableCellElement;
    private _ValidationIcon: HTMLSpanElement | null = null;
    public ColDef:kEditableColumn= new kEditableColumn();
    public ParentTable:kEditableTable|null = null;

    public RowIndex:number = 0;
    public ColumnIndex:number = 0;

    public ChoiceDD:kSelect|null = null;
    public ChoiceMultiDD:kHTMLMultiSelect|null = null;
    public DatePicker:kDateInput |null = null;
    public ColorPicker:HTMLInputElement|null = null;

    private _MouseOver = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ParentTable) {
                if (Event.buttons === 1) {
                    this.ParentTable.Selection.SelectionChangeMulti(this);
                }
             }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableRow._MouseOver");
            return;
        }
    }

    private _MouseDown = (_Event: MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ParentTable) {
                kEditableTable.SetActiveTable(this.ParentTable);
            }
            // Only reset selection and exit edit mode for left-clicks.
            // Right-clicks (button 2) must leave the existing selection intact so
            // context-menu actions like Fill Down see the full selected range.
            if (_Event.button !== 0) { return; }
            if (this.ParentTable && this.ParentTable.CurrenEditableCell) {
                const EditCell: kEditableTableCell = this.ParentTable.CurrenEditableCell;
                if (EditCell.UniqueID === this.UniqueID
                    && (EditCell.ChoiceMultiDD !== null || EditCell.ChoiceDD !== null || EditCell.DatePicker !== null)) {
                    return; // Click inside open dropdown/picker — leave it alone
                }
                EditCell.SetCellReadMode();
                this.ParentTable.CurrenEditableCell = null;
            }
            // Set the drag anchor to this cell so SelectionChangeMulti has the correct start point
            if (this.ParentTable) {
                this.ParentTable.Selection.RowIndexStart = this.RowIndex;
                this.ParentTable.Selection.RowIndexEnd = this.RowIndex;
                this.ParentTable.Selection.ColindexStart = this.ColumnIndex;
                this.ParentTable.Selection.ColIndexEnd = this.ColumnIndex;
                this.ParentTable.Selection._AnchorRow = this.RowIndex;
                this.ParentTable.Selection._AnchorCol = this.ColumnIndex;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._MouseDown");
        }
    }

    public CellClick = (Event?:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrTarget: HTMLElement|undefined = undefined;
            let InplaceClick:Boolean = false;
            if(Event){
                CurrTarget = <HTMLElement> Event.target;
            }
            const IsFormElement: boolean = CurrTarget instanceof HTMLSelectElement
                || CurrTarget instanceof HTMLInputElement
                || CurrTarget instanceof HTMLTextAreaElement;
            if(Event === undefined || undefined === CurrTarget || CurrTarget === this.Cell || (this.Cell.contains(CurrTarget) && !IsFormElement)){

                if (this.ParentTable) {
                    if(this.ParentTable.CurrenEditableCell){
                        InplaceClick = this.UniqueID === this.ParentTable.CurrenEditableCell.UniqueID
                    }
                    if (undefined === Event || Event.shiftKey === false) {
                        this.ParentTable.Selection.SetSingleCell(this);
                        if(this.ParentTable.RowClickCB && this.RowIndex >= 0){
                            const ClickedRow = this.ParentTable.Rows.Items[this.RowIndex];
                            if(ClickedRow){ this.ParentTable.RowClickCB(ClickedRow); }
                        }
                        const _ParentRow: kEditableTableRow | undefined = this.ParentTable.Rows.Items[this.RowIndex];
                        if (_ParentRow && _ParentRow.ReadOnly) { return; }
                        if (this.ColDef && this.ColDef.Locked === false) {
                            switch (this.ColDef.Type) {
                                case kHTMLEditableColType.Color:      this._EditColor();         break;
                                case kHTMLEditableColType.Select:     this._EditSelect();        break;
                                case kHTMLEditableColType.SelectMulti:
                                    if (Event) { Event.stopPropagation(); }
                                    this._EditSelectMulti();
                                    break;
                                case kHTMLEditableColType.Text:
                                case kHTMLEditableColType.Number:     this._EditTextOrNumber();  break;
                                case kHTMLEditableColType.Currency:   this._EditCurrency();      break;
                                case kHTMLEditableColType.Radio:
                                    this.SetNewValue(this.CurrentValue !== true);
                                    this.Cell.style.textAlign = "center";
                                    break;
                                case kHTMLEditableColType.Date:       this._EditDate();          break;
                                case kHTMLEditableColType.Checkbox:
                                    if (this.Cell.textContent === "☑") {
                                        this.Cell.textContent = "☐"; this.SetNewValue(false);
                                    } else {
                                        this.Cell.textContent = "☑"; this.SetNewValue(true);
                                    }
                                    this.Cell.style.textAlign = "center";
                                    break;
                                default:
                                    break;
                            }
                        }
                    } else {
                        this.ParentTable.Selection.SelectionChangeMulti(this);
                    }
                }
            if(Event){
                Event.stopPropagation();
                Event.preventDefault();
            }
        }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.CellClick");
            return;
        }
    }
    private _EditColor = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.ColorPicker = document.createElement("input");
            this.ColorPicker.type = "color";
            this.ColorPicker.value = ks.nz(this.CurrentValue);
            this.ColorPicker.style.width = "100%";
            this.ColorPicker.style.height = "90%";
            this.Cell.innerHTML = "";
            this.Cell.appendChild(this.ColorPicker);
            this.ColorPicker.focus();
            this.ColorPicker.click();
            this.ColorPicker.addEventListener("click", this.ColorChange);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._EditColor");
        }
    }
    private _EditSelect = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.ChoiceDD = new kSelect();
            if (this.ChoiceDD && this.ChoiceDD.Select && this.ColDef) {
                if (this.ColDef.Options.indexOf("") === -1) { this.ColDef.Options.push(""); }
                this.ChoiceDD.AddChoices(this.ColDef.Options);
                this.ChoiceDD.SetSelectedItem(ks.nz(this.Cell.textContent));
                this.Cell.innerHTML = "";
                this.ChoiceDD.Select.style.width = "100%";
                this.Cell.appendChild(this.ChoiceDD.Select);
                this.ChoiceDD.Select.focus();
                this.ChoiceDD.Select.click();
                this.ChoiceDD.ChangeCB = this.ChoiceDDChanged;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._EditSelect");
        }
    }
    private _EditSelectMulti = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.ChoiceMultiDD = new kHTMLMultiSelect();
            if (this.ChoiceMultiDD && this.ColDef) {
                if (this.ColDef.MultiSelectOptions) {
                    this.ChoiceMultiDD.ChoiceOptions = this.ColDef.MultiSelectOptions;
                } else {
                    this.ChoiceMultiDD.Choices = this.ColDef.Options;
                }
                if (this.ColDef.MultiSelectNoneSelectedOptionText !== "") {
                    this.ChoiceMultiDD.NoneSelectedOptionText = this.ColDef.MultiSelectNoneSelectedOptionText;
                }
                const CurrValue: string = ks.nz(this.Cell.textContent);
                this.Cell.innerHTML = "";
                const MultiChoiceDiv: HTMLDivElement = this.ChoiceMultiDD.ToDiv();
                MultiChoiceDiv.style.width = "90%";
                this.Cell.appendChild(MultiChoiceDiv);
                this.ChoiceMultiDD.OKClickCB = this._CompleteMultiSelectEdit;
                this.ChoiceMultiDD.SetSelectedChoices(CurrValue.split("; "));
                this.ChoiceMultiDD.ExpandListWrapper();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._EditSelectMulti");
        }
    }
    private _EditTextOrNumber = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Cell.contentEditable = "true";
            this.Cell.focus();
            const Range: Range = document.createRange();
            Range.selectNodeContents(this.Cell);
            const Sel: Selection | null = window.getSelection();
            if (Sel) { Sel.removeAllRanges(); Sel.addRange(Range); }
            this.Cell.addEventListener("beforeinput", this._TextEnterPrevent);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._EditTextOrNumber");
        }
    }
    private _EditCurrency = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Cell.contentEditable = "true";
            this.Cell.textContent = ks.NumberFromCurrency(this.CurrentValue).toString();
            this.Cell.focus();
            const Range: Range = document.createRange();
            Range.selectNodeContents(this.Cell);
            const Sel: Selection | null = window.getSelection();
            if (Sel) { Sel.removeAllRanges(); Sel.addRange(Range); }
            this.Cell.addEventListener("beforeinput", this._TextEnterPrevent);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._EditCurrency");
        }
    }
    private _EditDate = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.DatePicker = new kDateInput();
            this.DatePicker.Create();
            if (this.DatePicker && this.DatePicker.Input) {
                this.DatePicker.SetBykDate(this.OrgValue);
                this.Cell.textContent = "";
                this.DatePicker.Input.style.width = (this.Cell.clientWidth - 10) + "px";
                this.Cell.appendChild(this.DatePicker.Input);
                this.DatePicker.Input.focus();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._EditDate");
        }
    }
    private _CellRightClick = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable && this.ParentTable.CellsContextMenu){
                this.ParentTable.RightClickCell = this;
                switch (this.ParentTable.Selection.SelectionMode) {
                    case kEdTblSelectionMode.SingleCell:
                    case kEdTblSelectionMode.NoSelection:
                        Event.preventDefault();
                        Event.stopPropagation();
                        break;
                    default:
                        //Range Selected
                        this.ParentTable._UpdateFillMenuVisibility();
                        this.ParentTable.CellsContextMenu.ShowMenu(Event);
                        break;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CellRightClick");
            return;
        }
    }
    private _DirtyDebounceTimer: number = 0;
    private _FireDirtiedCallback = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ParentTable && this.ParentTable.CellDirtiedCB && this.ParentTable.PasteInProgress === false) {
                ks.DoCallBack(this.ParentTable.CellDirtiedCB, this, false);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._FireDirtiedCallback");
        }
    }
    public SetDirty(): void {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Dirty = true;
            this.Cell.style.fontWeight = "bold";
            if (this.ParentTable) {
                this.ParentTable.RecordEdit(this, this.OrgValue, this.CurrentValue);
            }
            window.clearTimeout(this._DirtyDebounceTimer);
            this._DirtyDebounceTimer = window.setTimeout(this._FireDirtiedCallback, kEditableTableCell.DIRTY_DEBOUNCE_MS);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SetDirty");
            return;
        }
    }
    public SetClean =(): void =>{
        if (ks.kErrorMode === true) { return; }
        try {
            this.Dirty = false;
            this.Cell.style.fontWeight = "normal";
            this.OrgValue = this.CurrentValue;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SetClean");
            return;
        }
    }

    public SetNewValue = (NewValue:any,SetDirty?:boolean): void => {  
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Cell && this.ParentTable && this.ColDef){
                switch (this.ColDef.Type) {
                    case kHTMLEditableColType.Date:
                        if(NewValue){
                            this.Cell.textContent = NewValue.ToLocalShortDate();
                        }
                        const OrgValDate:kTime |null = <kTime>this.OrgValue;
                        const NewDate:kTime |null = <kTime> NewValue;
                        if(OrgValDate && NewDate){
                            if(OrgValDate.ToISODate() !== NewDate.ToISODate()){
                                this.CurrentValue = NewValue;
                                if(SetDirty!==false){
                                    this.SetDirty();
                                }
                            }else{
                                this.SetClean();
                            }
                        }
                        break;
                    case kHTMLEditableColType.Color:
                        if(NewValue){
                            this.Cell.style.backgroundColor = NewValue;
                        }
                        if(NewValue !== this.OrgValue){
                            this.CurrentValue = NewValue;
                            if(SetDirty!==false){
                                this.SetDirty();
                            }
                        }else{
                            this.SetClean();
                        }
                        break;
                    case kHTMLEditableColType.Number:
                            if(NewValue !== this.OrgValue){
                                this.CurrentValue = ks.n0(NewValue);
                                this.Cell.textContent = this.CurrentValue.toString();
                                if(SetDirty!==false){
                                    this.SetDirty();
                                }
                            }else{
                                this.SetClean();
                            }
                            break;
                    case kHTMLEditableColType.Currency:
                            if(NewValue !== this.OrgValue){
                                if(typeof(NewValue) === "string"){
                                    this.CurrentValue = ks.NumberFromCurrency(NewValue);
                                }else{
                                    this.CurrentValue = ks.n0(NewValue);
                                }
                                this.Cell.textContent = ks.LocalCurrencyNumber(this.CurrentValue);
                                if(SetDirty!==false){
                                    this.SetDirty();
                                }
                            }else{
                                this.SetClean();
                            }
                            break;
                    case kHTMLEditableColType.SelectMulti:
                        if(NewValue !== this.OrgValue){
                            this.CurrentValue = NewValue;
                            this.Cell.textContent = this.CurrentValue;
                            if(SetDirty!==false){
                                this.SetDirty();
                            }
                        }else{
                            this.Cell.textContent = this.CurrentValue;
                            this.SetClean();
                        }
                        break;
                    case kHTMLEditableColType.Checkbox:
                        if(NewValue){
                            this.Cell.textContent = "☑";
                        }else{
                            this.Cell.textContent = "☐";
                        }
                        if(NewValue !== this.OrgValue){
                            this.CurrentValue = NewValue;
                            if(SetDirty!==false){
                                this.SetDirty();
                            }
                        }else{
                            this.SetClean();
                        }
                        break;
                    case kHTMLEditableColType.Radio:
                        this.Cell.innerHTML = this._RadioHtml(!!NewValue);
                        this.Cell.style.textAlign = "center";
                        if(NewValue){
                            let CurrOtherCell:kEditableTableCell;
                            let CurrRow:kEditableTableRow;
                            for(CurrRow of this.ParentTable.Rows.Items){
                                CurrOtherCell = CurrRow.Cells[this.ColumnIndex];
                                if(CurrOtherCell !== this && CurrOtherCell.CurrentValue === true){
                                    CurrOtherCell.SetNewValue(false);
                                }
                            }
                        }
                        if(NewValue !== this.OrgValue){
                            this.CurrentValue = NewValue;
                            if(SetDirty!==false){
                                this.SetDirty();
                            }
                        }else{
                            this.SetClean();
                        }
                        break;
                    case kHTMLEditableColType.Text:
                        this.Cell.textContent = ks.nz(NewValue);
                        if(this.Cell.textContent !== this.OrgValue){
                            this.CurrentValue = NewValue;
                            if(SetDirty!==false){
                                this.SetDirty();
                            }
                        }else{
                            this.SetClean();
                        }
                        if(this.RowIndex === this.ParentTable.Rows.Items.length-1){ // Last row
                            if(ks.nz(NewValue) !== "" && this.ParentTable.AddBlankRows === true){ // If not empty add a new row
                                this.ParentTable.AddEmptyRows(1);
                            }
                        }
                        break;
                    default:
                        this.Cell.textContent = ks.nz(NewValue);
                        if(this.Cell.textContent !== this.OrgValue){
                            this.CurrentValue = NewValue;
                            if(SetDirty!==false){
                                this.SetDirty();
                            }
                        }else{
                            this.SetClean();
                        }
                        break;
                }
            }
            this._ApplyValidation();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SetNewValue");
            return;
        }
    }
    private _ApplyValidation = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ColDef && this.ColDef.ValidationCB) {
                const Err: string | null = this.ColDef.ValidationCB(this.CurrentValue);
                if (Err !== null) {
                    this.Cell.style.outline = "2px solid #d13438";
                    this.Cell.title = Err;
                    if (!this._ValidationIcon) {
                        this._ValidationIcon = document.createElement("span");
                        this._ValidationIcon.className = "kValidationIcon";
                        this._ValidationIcon.textContent = "\u26A0";
                        this.Cell.appendChild(this._ValidationIcon);
                    }
                } else {
                    this.Cell.style.outline = "";
                    this.Cell.title = "";
                    if (this._ValidationIcon) {
                        this._ValidationIcon.remove();
                        this._ValidationIcon = null;
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._ApplyValidation");
        }
    }
    private  _TextEnterPrevent = (Event:any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(['insertParagraph', 'insertLineBreak'].indexOf(Event.inputType)>-1){
                Event.preventDefault();
                Event.stopPropagation();
                this.SelectNextDown();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._TextEnterPrevent");
            return;
        }
    }

    public ColorChange = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ColorPicker){
                this.SetNewValue(this.ColorPicker.value);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.ColorChange");
            return;
        }
    }

    public ChoiceDDChanged = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ChoiceDD && this.ChoiceDD.Select){
                this.SetNewValue(ks.nz(this.ChoiceDD.Select.value));
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.ChoiceDDChanged");
            return;
        }
    }
    public DateInputChanged = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.DatePicker){
                this.SetNewValue(this.DatePicker.ChosenDate);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.DateInputChanged");
            return;
        }
    }

    public SetCellReadMode = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ColDef && this.ParentTable) {
                switch (this.ColDef.Type) {
                    case kHTMLEditableColType.Select:      this._CompleteSelectEdit();    break;
                    case kHTMLEditableColType.Color:       this._CompleteColorEdit();     break;
                    case kHTMLEditableColType.SelectMulti: this._CompleteMultiSelectEdit(); break;
                    case kHTMLEditableColType.Date:        this._CompleteDateEdit();      break;
                    case kHTMLEditableColType.Text:        this._CompleteTextEdit();      break;
                    case kHTMLEditableColType.Currency:    this._CompleteCurrencyEdit();  break;
                    case kHTMLEditableColType.Number:      this._CompleteNumberEdit();    break;
                    case kHTMLEditableColType.Checkbox:
                    case kHTMLEditableColType.Radio:
                        break; // Always in read mode — nothing to do
                    default:
                        break;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SetCellReadMode");
            return;
        }
    }
    private _CompleteSelectEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ChoiceDD && this.ChoiceDD.Select) {
                this.SetNewValue(ks.nz(this.ChoiceDD.Select.value));
                this.ChoiceDD.Select.remove();
                this.ChoiceDD = null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteSelectEdit");
        }
    }
    private _CompleteColorEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ColorPicker !== null) {
                this.SetNewValue(this.ColorPicker.value, true);
                this.ColorPicker.remove();
                this.ColorPicker = null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteColorEdit");
        }
    }
    private _CompleteMultiSelectEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ChoiceMultiDD && this.ChoiceMultiDD.OuterDiv) {
                this.SetNewValue(this.ChoiceMultiDD.SelectedChoices().join("; "));
                this.ChoiceMultiDD.OuterDiv.remove();
                this.ChoiceMultiDD = null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteMultiSelectEdit");
        }
    }
    private _CompleteDateEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.DatePicker && this.DatePicker.Input) {
                this.SetNewValue(this.DatePicker.ChosenDate);
                this.Cell.textContent = (this.CurrentValue && this.CurrentValue.Year > 1970)
                    ? this.CurrentValue.ToLocalShortDate() : "";
                if ((this.CurrentValue === null) !== (this.OrgValue === null)) {
                    this.SetDirty();
                } else if (this.CurrentValue && this.OrgValue) {
                    if ((this.CurrentValue as kTime).ToISODate() !== (this.OrgValue as kTime).ToISODate()) {
                        this.SetDirty();
                    } else {
                        this.SetClean();
                    }
                } else {
                    this.SetClean();
                }
                this.DatePicker.Input.remove();
                this.DatePicker = null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteDateEdit");
        }
    }
    private _CompleteTextEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Cell.contentEditable = "false";
            if (this.Cell.textContent !== this.OrgValue) {
                this.SetNewValue(this.Cell.textContent, true);
                if (this.ParentTable && this.RowIndex === this.ParentTable.Rows.Items.length - 1) {
                    if (ks.nz(this.Cell.textContent) !== "") { this.ParentTable.AddEmptyRows(1); }
                }
            } else {
                this.SetClean();
            }
            this.Cell.removeEventListener("beforeinput", this._TextEnterPrevent);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteTextEdit");
        }
    }
    private _CompleteCurrencyEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Cell.contentEditable = "false";
            this.Cell.style.textAlign = "right";
            const CurrencyNumber: number = ks.NumberFromCurrency(ks.nz(this.Cell.textContent));
            if (CurrencyNumber !== this.OrgValue) {
                this.SetNewValue(CurrencyNumber);
                this.SetDirty();
                if (this.ParentTable && this.RowIndex === this.ParentTable.Rows.Items.length - 1) {
                    if (ks.nz(this.Cell.textContent) !== "") { this.ParentTable.AddEmptyRows(1); }
                }
            } else {
                this.SetClean();
            }
            this.Cell.removeEventListener("beforeinput", this._TextEnterPrevent);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteCurrencyEdit");
        }
    }
    private _CompleteNumberEdit = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Cell.contentEditable = "false";
            this.Cell.style.textAlign = "right";
            if (Number(this.Cell.textContent) !== this.OrgValue) {
                this.SetNewValue(Number(this.Cell.textContent));
                this.SetDirty();
                if (this.ParentTable && this.RowIndex === this.ParentTable.Rows.Items.length - 1) {
                    if (ks.nz(this.Cell.textContent) !== "") { this.ParentTable.AddEmptyRows(1); }
                }
            } else {
                this.SetClean();
            }
            this.Cell.removeEventListener("beforeinput", this._TextEnterPrevent);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell._CompleteNumberEdit");
        }
    }
    public SetCellOrgValue = (Value:any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Cell && this.ColDef){
                switch (this.ColDef.Type) {
                    case kHTMLEditableColType.Date:
                        if(Value){
                            this.Cell.textContent = Value.ToLocalShortDate();
                        }
                        break;                 
                    case kHTMLEditableColType.Currency:
                        if(Value){
                            this.Cell.textContent = ks.LocalCurrencyNumber(ks.n0(Value));
                            this.Cell.style.textAlign = "right";
                        }
                        break;
                    case kHTMLEditableColType.Number:                        
                        if(Value){
                            this.Cell.textContent = ks.n0(Value).toString();
                            this.Cell.style.textAlign = "right";
                        }
                        break;
                    case kHTMLEditableColType.Color:
                        if(Value){
                            this.Cell.style.backgroundColor = Value;
                        }
                        break;                        
                    case kHTMLEditableColType.Checkbox:
                        if(Value){
                            this.Cell.textContent = "☑";
                        }else{
                            this.Cell.textContent = "☐";
                        }
                        this.Cell.style.textAlign = "center";

                        break;
                    case kHTMLEditableColType.Radio:
                        this.Cell.innerHTML = this._RadioHtml(!!Value);
                        this.Cell.style.textAlign = "center";
                        break;
                    default:
                        this.Cell.textContent = ks.nz(Value);
                    break;
                }
                this.OrgValue = Value;
                this.CurrentValue = Value;
                if (this.ColDef.CustomRenderer !== null) {
                    this.ColDef.CustomRenderer(Value, this);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SetCellOrgValue");
            return;
        }
    }
    public SelectNextDown = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.Selection.SelectCellByIndexes(this.RowIndex+1,this.ColumnIndex);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SelectNextDown");
            return;
        }
    }
    public SelectNextUp = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.Selection.SelectCellByIndexes(this.RowIndex-1,this.ColumnIndex);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SelectNextUp");
            return;
        }
    }
    public SelectNextRight = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.Selection.SelectCellByIndexes(this.RowIndex,this.ColumnIndex +1);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SelectNextRight");
            return;
        }
    }
    public SelectNextLeft = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.Selection.SelectCellByIndexes(this.RowIndex,this.ColumnIndex -1);
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SelectNextLeft");
            return;
        }
    }
    public SelectNextRowFirstCell = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.Selection.SelectCellByIndexes(this.RowIndex+1,0);
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SelectNextRowFirstCell");
            return;
        }
    }
    public SelectPrevRowLastCell = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.Selection.SelectCellByIndexes(this.RowIndex-1,this.ParentTable.Columns.Items.length-1);
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SelectPrevRowLastCell");
            return;
        }
    }
    public SetSelectionMode = (NewMode:kEdTblSelectionMode): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Cell){
                switch (NewMode){
                    case kEdTblSelectionMode.SingleCell:
                        this.Cell.classList.add("SelectedCellSingle");
                        this.Cell.classList.remove("SelectedCellMulti");
                        break;
                    case kEdTblSelectionMode.NoSelection:
                        this.Cell.classList.remove("SelectedCellSingle");
                        this.Cell.classList.remove("SelectedCellMulti");
                        break;
                    default:
                        this.Cell.classList.add("SelectedCellMulti");
                        break
                }
            }
            this.SelectionMode = NewMode;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.SetSelectionMode");
            return;
        }
    }
    public Select = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Cell && this.ParentTable){
                switch(this.ColDef.Type){
                    case kHTMLEditableColType.Button:
                    case kHTMLEditableColType.Checkbox:
                    case kHTMLEditableColType.Radio:
                        this.ParentTable.Selection.SetSingleCell(this);
                        return;
                    default:
                        this.CellClick();
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableCell.Select");
            return;
        }
    }
}
export class kEditableTableCells extends kObjectArray{
    public Items:kEditableTableCell[] =[];
}

export enum kHTMLEditableColType{
    Text = 1,
    Number = 2,
    Date = 3,
    Time = 4,
    DateTime = 5,
    Checkbox = 6,
    Select = 7,
    Button = 8,
    Link = 9,
    Image = 10,
    File = 11,
    Color = 12,
    SelectMulti = 13,
    Radio = 14,
    Currency = 15 //Number formatted with currency characters
}
export class kEditableColumn extends kObject {
    public Width: number = 100;
    public Type: kHTMLEditableColType = kHTMLEditableColType.Text;
    public Options: Array<string> = new Array<string>();
    public MultiSelectOptions: Array<kMultiSelectOption> =[];
    public MultiSelectNoneSelectedOptionText:string ="";
    public kObjectPropertyName: string = "Title";
    public Locked: boolean = false;
    public DefaultValue: any = null;
    public Icon:HTMLImageElement|null|undefined = null;
    public Resizable: boolean = true;
    public Frozen: boolean = false;
    public _FrozenLeft: number = -1;
    public CustomRenderer: ((value: any, cell: kEditableTableCell) => void) | null = null;
    public ValidationCB: ((value: any) => string | null) | null = null;
}
export class kEditableColumns extends kObjectArray{
    public Items: kEditableColumn[] = [];
}
export enum kEdTblSelectionMode{
    NoSelection ="NoSelection",
    SingleCell = "SingleCell",

    SingleRow = "SingleRow",
    MultipleRowsExtendUp = "MultipleRowsExtendUp",
    MultipleRowsExtendDown = "MultipleRowsExtendDown",

    SingleColumn = "SingleColumn",
    MultipleColsExtendRight ="MultipleColsExtendRight",
    MultipleColsExtendLeft ="MultipleColsExtendLeft",

    CustomExtRightDown = "CustomExtRightDown",
    CustomExtRightUp ="CustomExtRightUp",
    CustomExtLeftDown = "CustomExtLeftDown",
    CustomExtLeftUp = "CustomExtLeftUp",
    SelectAll = "SelectAll"    
}
export class kEditableCellSelection{

    public SelectionMode:kEdTblSelectionMode = kEdTblSelectionMode.NoSelection;
    
    public RowIndexStart:number = 0;
    public RowIndexEnd:number = 0

    public ColindexStart:number = 0;
    public ColIndexEnd:number = 0;

    public _AnchorRow: number = 0;
    public _AnchorCol: number = 0;

    public SelectedRows: number = 1;
    public SelectedCols: number = 1;
    private _PrevSelectedCells: kEditableTableCell[] = [];
    public ClearPrev = (): void => { this._PrevSelectedCells = []; }

    public SetSingleCell = (CurrCell:kEditableTableCell): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.ParentTable){
                if (this.ParentTable.CurrenEditableCell) { //If there was a previously selected cell
                    this.ParentTable.CurrenEditableCell.SetCellReadMode();
                }
                if (this.ParentTable.RowContextMenu) {
                    this.ParentTable.RowContextMenu.OutsideClick();
                }

                CurrCell.SetSelectionMode(kEdTblSelectionMode.SingleCell);
                this.ParentTable.CurrenEditableCell = CurrCell;
                this.ColindexStart = CurrCell.ColumnIndex;
                this.ColIndexEnd = CurrCell.ColumnIndex;
                this.RowIndexStart = CurrCell.RowIndex;
                this.RowIndexEnd = CurrCell.RowIndex;

                this.SelectedRows = 1;
                this.SelectedCols = 1;
                this.SelectionMode = kEdTblSelectionMode.SingleCell;
                this.UpdateSelectionStyles();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SetSingleCell");
            return;
        }
    }
    public SetSingleRowSelected = (CurrentRow:kEditableTableRow):void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.SelectionMode = kEdTblSelectionMode.SingleRow;
                this.RowIndexStart = CurrentRow.Index;
                this.RowIndexEnd = CurrentRow.Index;
                this.ColindexStart = 0;
                this.ColIndexEnd = this.ParentTable.Columns.Items.length - 1;
                this.SelectedCols = this.ColIndexEnd - this.ColindexStart+1;
                this.UpdateSelectionStyles();
                this.ClearTextSelection();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SetSingleRowSelected");
            return ;
        }
    }
    public SetSingleColSelected = (CurrCol:kEditableColumn):void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.SelectionMode = kEdTblSelectionMode.SingleColumn;
                this.RowIndexStart = 0;
                this.RowIndexEnd = this.ParentTable.Rows.Items.length -1;
                this.SelectedRows =this.RowIndexEnd - this.RowIndexStart;
                this.ColindexStart = CurrCol.Index;
                this.ColIndexEnd = CurrCol.Index;
                this.SelectedCols = 1;
                this.UpdateSelectionStyles();
                this.ClearTextSelection();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SetSingleColSelected");
            return ;
        }
    } 
    public ClearTextSelection = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const Sel = window.getSelection();
            if(Sel){
                Sel.empty();
                Sel.removeAllRanges();
            }
        } catch (e) {
            //Ignore errors here;
            return ;
        }
    }
    public SelectAll = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.SelectionMode = kEdTblSelectionMode.SelectAll;
                this.RowIndexStart =  0;
                this.RowIndexEnd = this.ParentTable.Rows.Items.length -1;
                this.ColindexStart = 0;
                this.ColIndexEnd = this.ParentTable.Columns.Items.length - 1;
                this.SelectedCols = this.ParentTable.Columns.Items.length;
                this.SelectedRows = this.ParentTable.Rows.Items.length;
            }
            this.UpdateSelectionStyles();
            this.ClearTextSelection();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SelectAll");
            return ;
        }
    }
    private _CheckSingleCell = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                if(this.SelectedCols === 1){
                    if(this.SelectedRows ===1){
                        this.SelectionMode = kEdTblSelectionMode.SingleCell;
                        this.ParentTable.CurrenEditableCell = this.ParentTable.GetCellByIndexes(this.RowIndexStart,this.ColindexStart);
                    }
                }
                if(this.SelectionMode!== kEdTblSelectionMode.SingleCell){
                    if(this.ParentTable.CurrenEditableCell){
                        this.ParentTable.CurrenEditableCell.SetCellReadMode();
                        this.ParentTable.CurrenEditableCell = null;
                    }
                }
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection._CheckSingleCell");
            return ;
        }
    }
    public ExpandRight = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                switch(this.SelectionMode){
                    case kEdTblSelectionMode.SingleCell:
                        this.SelectionMode = kEdTblSelectionMode.CustomExtRightDown;
                        this.SelectedCols ++;
                        this.ColIndexEnd ++;
                        if((this.ColIndexEnd)>this.ParentTable.Columns.Items.length){
                            this.SelectedCols --;
                            this.ColIndexEnd --;
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtRightDown:
                    case kEdTblSelectionMode.CustomExtRightUp:
                        this.ColIndexEnd ++;
                        if(this.ColIndexEnd>(this.ParentTable.Columns.Items.length-1)){
                            this.ColIndexEnd --;
                        }else{
                            this.SelectedCols ++;
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtLeftDown:
                    case kEdTblSelectionMode.CustomExtLeftUp:
                        if(this.SelectedCols===1){
                            if(this.SelectionMode === kEdTblSelectionMode.CustomExtLeftDown){
                                this.SelectionMode = kEdTblSelectionMode.CustomExtRightDown;
                            }else{
                                this.SelectionMode = kEdTblSelectionMode.CustomExtRightUp;
                            }
                            this.SelectedCols++;
                            this.ColIndexEnd ++;
                        }else{
                            this.SelectedCols --;
                            this.ColindexStart ++;    
                        }
                        break;
                    case kEdTblSelectionMode.SingleColumn:
                        this.SelectedCols++;
                        this.ColIndexEnd ++;
                        if(this.ColIndexEnd > this.ParentTable.Columns.Items.length){
                            this.SelectedCols --;
                            this.ColIndexEnd --;
                        }else{
                            this.SelectionMode = kEdTblSelectionMode.MultipleColsExtendRight;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleColsExtendRight:
                        this.SelectedCols++;
                        this.ColIndexEnd ++;
                        if(this.ColIndexEnd > (this.ParentTable.Columns.Items.length -1)){
                            this.SelectedCols --;
                            this.ColIndexEnd --;
                        }
                        break;
                }
                this._CheckSingleCell();
                this.UpdateSelectionStyles();
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.ExpandRight");
            return ;
        }
    }
    public ExpandUp = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                switch(this.SelectionMode){
                    case kEdTblSelectionMode.SingleCell:
                        this.SelectionMode = kEdTblSelectionMode.CustomExtRightUp;
                        this.RowIndexStart --;
                        if(this.RowIndexStart<0){
                            this.RowIndexStart ++;
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtRightDown:
                    case kEdTblSelectionMode.CustomExtLeftDown:
                        if(this.RowIndexEnd>0){
                            if(this.SelectedRows >1){
                                this.RowIndexEnd --;
                            }else{
                                if(this.SelectionMode ===kEdTblSelectionMode.CustomExtLeftDown){
                                    this.SelectionMode = kEdTblSelectionMode.CustomExtLeftUp;
                                }else{
                                    this.SelectionMode = kEdTblSelectionMode.CustomExtRightUp;
                                }
                                this.RowIndexStart --;
                            }
                        }                        
                        break;

                    case kEdTblSelectionMode.CustomExtRightUp:
                    case kEdTblSelectionMode.CustomExtLeftUp:
                        if(this.RowIndexStart>0){
                            this.RowIndexStart --;
                        }
                        break;
                    case kEdTblSelectionMode.SingleRow:
                        if(this.RowIndexStart>0){
                            this.RowIndexStart --;
                            this.SelectedRows = 2;
                            this.SelectionMode = kEdTblSelectionMode.MultipleRowsExtendUp;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleRowsExtendUp:
                        if(this.RowIndexStart>0){
                            this.RowIndexStart --;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleRowsExtendDown:
                        if(this.RowIndexEnd >0){
                            this.RowIndexEnd --;
                            if(this.SelectedRows === 1){
                                this.SelectionMode = kEdTblSelectionMode.SingleRow;
                            }
                        }
                        break;
    
                    }
                this.UpdateSelectionStyles();
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.ExpandUp");
            return ;
        }
    } 
    public ExpandDown = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                switch(this.SelectionMode){
                    case kEdTblSelectionMode.SingleCell:
                        if(this.RowIndexEnd<(this.ParentTable.Rows.Items.length -1)){
                            this.SelectionMode = kEdTblSelectionMode.CustomExtRightDown;
                            this.RowIndexEnd ++;
                            this.SelectedRows = 2;
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtRightDown:
                    case kEdTblSelectionMode.CustomExtLeftDown:
                        if(this.RowIndexEnd<(this.ParentTable.Rows.Items.length -1)){
                            this.RowIndexEnd ++;
                        }                                            
                        break;

                    case kEdTblSelectionMode.CustomExtRightUp:
                    case kEdTblSelectionMode.CustomExtLeftUp:
                        if(this.SelectedRows>1){
                            this.RowIndexStart ++;
                        }else{
                            if(this.SelectionMode === kEdTblSelectionMode.CustomExtRightUp){
                                this.SelectionMode = kEdTblSelectionMode.CustomExtRightDown;
                            }else{
                                this.SelectionMode = kEdTblSelectionMode.CustomExtLeftDown;;
                            }
                            this.RowIndexEnd ++;
                        }
                        break;
                    case kEdTblSelectionMode.SingleRow:
                        if(this.RowIndexEnd<(this.ParentTable.Rows.Items.length -1)){
                            this.RowIndexEnd ++;
                            this.SelectedRows = 2;
                            this.SelectionMode = kEdTblSelectionMode.MultipleRowsExtendDown;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleRowsExtendUp:
                        this.RowIndexStart ++;
                        if(this.SelectedRows === 1){
                            this.SelectionMode = kEdTblSelectionMode.SingleRow;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleRowsExtendDown:
                        if(this.RowIndexEnd <(this.ParentTable.Rows.Items.length -1)){
                            this.RowIndexEnd ++;
                        }
                        break;
    
                    }
                this.UpdateSelectionStyles();
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.ExpandDown");
            return ;
        }
    }
    public ExpandLeft = ():void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                switch(this.SelectionMode){
                    case kEdTblSelectionMode.SingleCell:
                        this.SelectionMode = kEdTblSelectionMode.CustomExtLeftDown;
                        this.SelectedCols ++;
                        this.ColindexStart --;
                        if(this.ColindexStart<0){
                            this.SelectedCols --;
                            this.ColindexStart ++;
                            this.SelectionMode = kEdTblSelectionMode.SingleCell;
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtLeftDown:
                    case kEdTblSelectionMode.CustomExtLeftUp:
                        this.ColindexStart --;
                        if(this.ColindexStart<0){
                            this.ColindexStart =0;
                        }else{
                            this.SelectedCols ++;
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtRightDown:
                    case kEdTblSelectionMode.CustomExtRightUp:
                        if(this.SelectedCols>1){
                            this.SelectedCols --;
                            this.ColIndexEnd --;
                        }else{
                            if(this.SelectionMode === kEdTblSelectionMode.CustomExtRightDown){
                                this.SelectionMode = kEdTblSelectionMode.CustomExtLeftDown;
                            }else{
                                this.SelectionMode = kEdTblSelectionMode.CustomExtLeftUp;
                            }
                            this.SelectedCols++;
                            this.ColindexStart --;
                        }
                        break;
                    case kEdTblSelectionMode.SingleColumn:
                        this.SelectedCols++;
                        this.ColindexStart --;
                        if(this.ColindexStart < 0){
                            this.SelectedCols --;
                            this.ColindexStart = 0;
                        }else{
                            this.SelectionMode = kEdTblSelectionMode.MultipleColsExtendLeft;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleColsExtendLeft:
                        this.SelectedCols++;
                        this.ColindexStart --;
                        if(this.ColindexStart <0){
                            this.SelectedCols --;
                            this.ColindexStart = 0;
                        }
                        break;
                    case kEdTblSelectionMode.MultipleColsExtendRight:
                        this.SelectedCols--;
                        this.ColIndexEnd --;
                        if(this.ColIndexEnd <0){
                            this.SelectedCols --;
                            this.ColindexStart = 0;
                        }
                }
                this.UpdateSelectionStyles();
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.ExpandLeft");
            return ;
        }
    }
    public SetSelectionByIndexes = (SelectionMode:kEdTblSelectionMode):void=>{
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrRoRowIndex:number = 0;
            let CurrColIndex:number = 0;
            let CurrRow:kEditableTableRow;
            let CurrCell:kEditableTableCell; 
            if(this.ParentTable){
                for(CurrRoRowIndex=this.RowIndexStart;CurrRoRowIndex<=this.RowIndexEnd;CurrRoRowIndex++){
                    CurrRow = this.ParentTable.Rows.Items[CurrRoRowIndex];
                    for(CurrColIndex = this.ColindexStart;CurrColIndex<=this.ColIndexEnd;CurrColIndex++){
                        CurrCell = CurrRow.Cells[CurrColIndex];
                        CurrCell.SelectionMode =  SelectionMode;
                    }
                }
            }
            this.SelectionMode = SelectionMode;
            this.UpdateSelectionStyles();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SetSelectionByIndexes")
        }
    }
    public ParentTable: kEditableTable | null = null;
    public GetSelectedText = (): string => {
        if (ks.kErrorMode === true) { return ""; }
        try {
            let CurrRow: kEditableTableRow;
            let CurrentCell: kEditableTableCell;
            let Currcol:kEditableColumn
            let SelectedText: string = "";
            let CurrRowText: string = "";
            if (this.ParentTable) {
                if(this.SelectionMode=== kEdTblSelectionMode.SelectAll){
                    for(Currcol of this.ParentTable.Columns.Items){
                        SelectedText += Currcol.Title + "\t";
                    }
                    SelectedText += "\n";
                }
                for (CurrRow of this.ParentTable.Rows.Items) {
                    CurrRowText = "";
                    for (CurrentCell of CurrRow.Cells) {
                        if (CurrentCell.Cell.classList.contains("SelectedCellSingle") || CurrentCell.Cell.classList.contains("SelectedCellMulti")) {
                            CurrentCell.SetCellReadMode();
                            if (CurrentCell.CurrentValue !== null) {
                                switch (CurrentCell.ColDef.Type) {
                                    case kHTMLEditableColType.Date:
                                        CurrRowText += CurrentCell.CurrentValue.ToISODate();
                                        break;
                                    default:
                                        CurrRowText += CurrentCell.CurrentValue;
                                        break;
                                }

                            }
                            if (this.SelectionMode === kEdTblSelectionMode.SingleCell) {
                                return CurrRowText;
                            } else {
                                if (this.SelectedCols > 1) {
                                    CurrRowText += "\t";
                                }
                            }
                        }

                    }
                    if (CurrRowText !== "") {
                        SelectedText += CurrRowText + "\n";
                    }
                }
            }
            return SelectedText;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.GetSelectedText");
            return "";
        }
    }
    public GetTopLeftCell = ():kEditableTableCell|null=>{
        if (ks.kErrorMode === true) { return null; }
        try {
            if(this.ParentTable){
                const TopRow:kEditableTableRow = this.ParentTable.Rows.Items[this.RowIndexStart];
                if(TopRow.Cells.length>0){
                    return TopRow.Cells[this.ColindexStart];
                }   
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.GetTopoLeftCell");
        }
        return null;
    }
    public GetTopRigthCell = ():kEditableTableCell|null=>{
        if (ks.kErrorMode === true) { return null; }
        try {
            if(this.ParentTable){
                const TopRow:kEditableTableRow = this.ParentTable.Rows.Items[this.RowIndexStart];
                if(TopRow.Cells.length>0){
                    return TopRow.Cells[this.ColIndexEnd];
                }   
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.GetTopRigthCell");
        }
        return null;
    }
    public SelectionChangeMulti = (NewSelectedCell:kEditableTableCell): void => {
        if (ks.kErrorMode === true) { return; }
        try {

            if (this.ParentTable) {
                if (this.ParentTable.CurrenEditableCell) {
                    this.ParentTable.CurrenEditableCell.SetCellReadMode();
                    this.ParentTable.CurrenEditableCell = null;
                }
                if (this.ParentTable.RowContextMenu) {
                    this.ParentTable.RowContextMenu.OutsideClick();
                }

            }
            if (this._AnchorRow <= NewSelectedCell.RowIndex) {
                this.RowIndexStart = this._AnchorRow;
                this.RowIndexEnd = NewSelectedCell.RowIndex;
            } else {
                this.RowIndexStart = NewSelectedCell.RowIndex;
                this.RowIndexEnd = this._AnchorRow;
            }
            if (this._AnchorCol <= NewSelectedCell.ColumnIndex) {
                this.ColindexStart = this._AnchorCol;
                this.ColIndexEnd = NewSelectedCell.ColumnIndex;
            } else {
                this.ColindexStart = NewSelectedCell.ColumnIndex;
                this.ColIndexEnd = this._AnchorCol;
            }
            if (this._AnchorRow <= NewSelectedCell.RowIndex) {
                this.SelectionMode = this._AnchorCol <= NewSelectedCell.ColumnIndex
                    ? kEdTblSelectionMode.CustomExtRightDown : kEdTblSelectionMode.CustomExtLeftDown;
            } else {
                this.SelectionMode = this._AnchorCol <= NewSelectedCell.ColumnIndex
                    ? kEdTblSelectionMode.CustomExtLeftUp : kEdTblSelectionMode.CustomExtRightUp;
            }
            this.SelectedCols = this.ColIndexEnd - this.ColindexStart;
            this.SelectedRows = this.RowIndexEnd - this.RowIndexStart;
            this.UpdateSelectionStyles();
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SelectionChangeMulti");
            return;
        }
    }
    public GetSelectedCells = (): kEditableTableCell[] => {
        const SelectedCells:kEditableTableCell[] = [];
        let Counter:number = 0;
        let CountCells:number = 0;
        let CurrRow:kEditableTableRow;
        let CurrCell:kEditableTableCell;
        if (ks.kErrorMode === true) { return SelectedCells; }
        try {
            if(this.ParentTable){
                switch (this.SelectionMode){
                    case kEdTblSelectionMode.SingleCell:
                        if(this.ParentTable.CurrenEditableCell){
                            SelectedCells.push(this.ParentTable.CurrenEditableCell);
                        }else{
                            this.SelectionMode = kEdTblSelectionMode.NoSelection;
                            console.log("Wrong selection mode!")
                        }
                        break;
                    case kEdTblSelectionMode.SingleColumn:
                        for(CurrRow of this.ParentTable.Rows.Items){
                            SelectedCells.push(CurrRow.Cells[this.ColindexStart]);
                        }
                        break;
                    case kEdTblSelectionMode.MultipleColsExtendRight:
                    case kEdTblSelectionMode.MultipleColsExtendLeft:
                        for(Counter=this.ColindexStart;Counter <= this.ColIndexEnd;Counter ++){
                            for(CurrRow of this.ParentTable.Rows.Items){
                                SelectedCells.push(CurrRow.Cells[Counter]);
                            }
                        }
                        break;
                    case kEdTblSelectionMode.SingleRow:
                        CurrRow = this.ParentTable.Rows.Items[this.RowIndexStart]
                        for(CurrCell of CurrRow.Cells){
                            SelectedCells.push(CurrCell);
                        }
                        break;
                    case kEdTblSelectionMode.MultipleRowsExtendDown:
                    case kEdTblSelectionMode.MultipleRowsExtendUp:
                    case kEdTblSelectionMode.SelectAll:
                        for(Counter = this.RowIndexStart;Counter<=this.RowIndexEnd;Counter ++){
                            CurrRow = this.ParentTable.Rows.Items[Counter]
                            for(CurrCell of CurrRow.Cells){
                                SelectedCells.push(CurrCell);
                            }
                        }
                        break;
                    case kEdTblSelectionMode.CustomExtRightDown:
                    case kEdTblSelectionMode.CustomExtLeftDown:
                    case kEdTblSelectionMode.CustomExtRightUp:
                    case kEdTblSelectionMode.CustomExtLeftUp:
                        for(Counter = this.RowIndexStart;Counter <=this.RowIndexEnd;Counter ++){
                            CurrRow = this.ParentTable.Rows.Items[Counter];
                            for(CountCells = this.ColindexStart;CountCells<=this.ColIndexEnd;CountCells++){
                                SelectedCells.push(CurrRow.Cells[CountCells]);
                            }
                        } 
                        break;
                }
            }
            if(this.SelectionMode!== kEdTblSelectionMode.NoSelection){
                this.SelectedCols = this.ColIndexEnd - this.ColindexStart +1;
                this.SelectedRows = this.RowIndexEnd - this.RowIndexStart +1;
            }else{
                this.SelectedCols = 0;
                this.SelectedRows = 0;
            }
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.GetSelectedCells");
        }
        return SelectedCells
    }
    public GetSelectedRows = (): kEditableTableRows => {
        const SelectedRows:kEditableTableRows = new kEditableTableRows();

        if (ks.kErrorMode === true) { return SelectedRows; }
        try {
            let RowCounter:number = 0;
            if(this.ParentTable){
                for(RowCounter=this.RowIndexStart;RowCounter<=this.RowIndexEnd;RowCounter++){
                    SelectedRows.push(this.ParentTable.Rows.Items[RowCounter]);
                }
            }
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.GetSelectedRows");
        }
        return SelectedRows
    }
    public UpdateSelectionStyles = (): void => {
        this._CheckSingleCell();
        const SelectedCells: kEditableTableCell[] = this.GetSelectedCells();
        const SelectedIds: Set<number> = new Set<number>();
        for (const CurrCell of SelectedCells) {
            SelectedIds.add(CurrCell.UniqueID);
        }
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ParentTable) {
                for (const PrevCell of this._PrevSelectedCells) {
                    if (!SelectedIds.has(PrevCell.UniqueID)) {
                        PrevCell.Cell.classList.remove("SelectedCellMulti");
                        PrevCell.Cell.classList.remove("SelectedCellSingle");
                        PrevCell.Cell.classList.remove("SelectedFirstRow");
                        PrevCell.Cell.setAttribute("aria-selected", "false");
                    }
                }
                if (this.SelectionMode === kEdTblSelectionMode.SingleCell) {
                    if (SelectedCells.length > 0) {
                        SelectedCells[0].Cell.classList.remove("SelectedCellMulti");
                        SelectedCells[0].Cell.classList.add("SelectedCellSingle");
                        SelectedCells[0].Cell.setAttribute("aria-selected", "true");
                    }
                } else {
                    if (this.ParentTable.CurrenEditableCell) {
                        this.ParentTable.CurrenEditableCell.SetCellReadMode();
                    }
                    for (const CurrCell of SelectedCells) {
                        CurrCell.Cell.classList.add("SelectedCellMulti");
                        CurrCell.Cell.classList.remove("SelectedCellSingle");
                        CurrCell.Cell.setAttribute("aria-selected", "true");
                        if (CurrCell.RowIndex === this.RowIndexStart && this.SelectedRows > 1) {
                            CurrCell.Cell.classList.add("SelectedFirstRow");
                        } else {
                            CurrCell.Cell.classList.remove("SelectedFirstRow");
                        }
                    }
                }
                this._PrevSelectedCells = SelectedCells;
                if (this.ParentTable && this.ParentTable.SelectionChangedCB) {
                    this.ParentTable.SelectionChangedCB();
                }
            }
            if (SelectedIds.size > 1) {
                this.ClearTextSelection();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.UpdateSelectionStyles");
        }
    }
    public SelectLastCell = (): void => {
        let CurrRow:kEditableTableRow;
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                CurrRow = this.ParentTable.Rows.Items[this.RowIndexStart];
                CurrRow.SelectLastCell();

            }
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SelectLastCell");
        }
    }
    public SelectFirstCell = (): void => {
        let CurrRow:kEditableTableRow;;
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                CurrRow = this.ParentTable.Rows.Items[this.RowIndexStart];
                CurrRow.SelectFirstCell();
            }
       } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SelectFirstCell");
        }
    }
    public SelectCellByIndexes = (RowIndex:number,ColIndex:number): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.ParentTable){
                let CurrCell:kEditableTableCell = this.ParentTable.GetCellByIndexes(RowIndex,ColIndex);                
                if (CurrCell.ColDef && CurrCell.ParentTable){
                    CurrCell.Select();
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableCellSelection.SelectCellByIndexes");
            return ;
        }
    }

}
export class kEditableTableHeading{
    public Title:string = "";
    public HeaderCell:HTMLTableCellElement|null = null;
    public SortButton:HTMLSpanElement|null = null;
    public SortedAscending:boolean = true;
    public Sorted:boolean = false;
    public ParentTable:kEditableTable|null = null;
    public ColumnIndex:number = 0;
    public Sortable:boolean = true;
    public RowBeingRightClick:kEditableTableRow|null = null;
    public RightClickColumn:kEditableTableHeading|null = null;
    constructor(Title:string,Sortable:boolean = true,Icon:HTMLImageElement|null|undefined){
        this.Title = Title;
        this.HeaderCell = document.createElement("th");
        if(Icon){
            const IconStyle:kStyleClass = kStyles.AddStyle("kEdTblHeaderIcon");
            if(IconStyle.Saved === false){
                IconStyle.Style.position = "relative";
                IconStyle.Style.top = "1px";
            }
            IconStyle.Apply(Icon);
            this.HeaderCell.appendChild(Icon);
            if(ks.nz(Title)!==""){
                const HeaderLabel:HTMLSpanElement = document.createElement("span");
                HeaderLabel.textContent = Title;

                const LabelStyle:kStyleClass = kStyles.AddStyle("kEdTblHeaderLabelWithIcon");
                LabelStyle.Style.marginLeft = "2px";;
                LabelStyle.Apply(HeaderLabel);
                
                this.HeaderCell.appendChild(HeaderLabel);
            }
        }else{
            this.HeaderCell.textContent = Title;
        }
        this.HeaderCell.addEventListener("click",this.HeadingClick);
        this.Sortable = Sortable;
        if(this.Sortable){
            this.HeaderCell.addEventListener("contextmenu",this.HeaderRightClick);
            this.HeaderCell.addEventListener("dblclick",this.ColumnDblClick);
            this.SortButton = document.createElement("span");
            //this.SortButton.style.cursor = "pointer";
            this.SortButton.style.cssFloat = "right";
            this.SortButton.style.paddingRight = "4px";
            this.SetUnsorted();
            // this.SortButton.addEventListener("click",this.SortClick);
            this.HeaderCell.appendChild(this.SortButton);

        } 
    }
    public HeadingClick = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        let CurrCol:kEditableColumn;
        try {
            if(this.ParentTable){
                CurrCol = this.ParentTable.Columns.Items[this.ColumnIndex]
                this.ParentTable.Selection.SetSingleColSelected(CurrCol);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableHeading.HeadingClick");
            return;
        }
    }
    public HeaderRightClick = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable && this.ParentTable.ColContextMenu){
                this.ParentTable.RightClickColumn = this;
                this.ParentTable.ColContextMenu.ShowMenu(Event);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableHeading.HeaderRightClick");
            return;
        }
    }
    public ColumnDblClick = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.SortByColumn(this.ColumnIndex);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableHeading.ColumnDblClick");
            return;
        }
    }
    public SetUnsorted = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.SortButton){
                //this.SortButton.innerHTML = "&#8645;";
                this.SortButton.innerText ="";
                this.SortedAscending = false;
                this.Sorted =false;
                this.SortButton.style.fontWeight = "normal";
                this.SortButton.style.color = "#323130";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTableHeading.SetUnsorted ");
            return;
        }
    }
}
export class GridValue{
    public OriginalValue:any = null;
    public CurrentValue:any = null;
    public Dirty:boolean = false;
    public Column:kEditableColumn|null = null;
}

export class kCellEditCommand {
    private _Cell: kEditableTableCell;
    private _OldValue: any;
    private _NewValue: any;

    constructor(Cell: kEditableTableCell, OldValue: any, NewValue: any) {
        this._Cell = Cell;
        this._OldValue = OldValue;
        this._NewValue = NewValue;
    }

    public Undo = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this._Cell.SetNewValue(this._OldValue, false);
            this._Cell.SetClean();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCellEditCommand.Undo");
        }
    }

    public Redo = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this._Cell.SetNewValue(this._NewValue, false);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCellEditCommand.Redo");
        }
    }
}

export class kEditableTable{

    private static readonly SELECTION_POLL_MS: number = 200;
    private static _ActiveTable: kEditableTable | null = null;
    public static SetActiveTable = (Table: kEditableTable): void => { kEditableTable._ActiveTable = Table; }

    private _IntervalId: number = 0;

    constructor() {
        this.Selection.ParentTable = this;
        this.AddStyles();
        this._IntervalId = window.setInterval(this.CheckSelectionChange, kEditableTable.SELECTION_POLL_MS);
    }

    public Destroy = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            window.clearInterval(this._IntervalId);
            document.removeEventListener("keydown", this.KeyDown);
            if (this.Table) {
                this.Table.removeEventListener("paste", this.PasteHandler);
                this.Table.removeEventListener("mouseenter", this.MouseEnter);
            }
            if (kEditableTable._ActiveTable === this) {
                kEditableTable._ActiveTable = null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.Destroy");
        }
    }
    public CellSelectionChangedCB:any = null;
    public SelectionChangedCB:any = null;
    public CellDirtiedCB:any = null;
    public RowDeletedCB:any = null;
    //public CellRightClickCB:any = null;
    public RowRightClickCB:any = null;
    public RowClickCB:any = null;
    public OnSorted: ((ColumnIndex: number, Ascending: boolean) => void) | null = null;

    // Undo/Redo
    public MaxUndoSteps: number = 50;
    private _UndoStack: kCellEditCommand[] = [];
    private _RedoStack: kCellEditCommand[] = [];

    public RecordEdit = (Cell: kEditableTableCell, OldValue: any, NewValue: any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this._RedoStack = [];
            this._UndoStack.push(new kCellEditCommand(Cell, OldValue, NewValue));
            if (this._UndoStack.length > this.MaxUndoSteps) {
                this._UndoStack.shift();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.RecordEdit");
        }
    }

    public Undo = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const Cmd: kCellEditCommand | undefined = this._UndoStack.pop();
            if (Cmd) {
                this._RedoStack.push(Cmd);
                Cmd.Undo();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.Undo");
        }
    }

    public Redo = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const Cmd: kCellEditCommand | undefined = this._RedoStack.pop();
            if (Cmd) {
                this._UndoStack.push(Cmd);
                Cmd.Redo();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.Redo");
        }
    }

    public Columns: kEditableColumns = new kEditableColumns();

    public Table: HTMLTableElement = document.createElement("table");
    public RowValues:kObjectArrayCore|null = null;
    public Rows: kEditableTableRows = new kEditableTableRows();

    public CurrenEditableCell:kEditableTableCell|null = null;
    public RangeSeleced:boolean = false;
    public Headers:Array<kEditableTableHeading> = new Array<kEditableTableHeading>();
    
    public RowContextMenu:kContextMenu|null = null;
    public ColContextMenu:kContextMenu|null = null;

    public CellsContextMenu:kContextMenu|null = null;

    public RightClickColumn:kEditableTableHeading|null = null;
    public RightClickRow:kEditableTableRow|null = null;
    public RightClickCell:kEditableTableCell|null = null;

    public StartCell: kEditableTableCell | null = null;
    public Selection: kEditableCellSelection = new kEditableCellSelection();

    public AddBlankRows: boolean = true;
    public PasteInProgress: boolean = false;
    public AlternateRowShading: boolean = false;
    public AlternateRowColor: string = "rgba(129,71,255,0.03)";
 
    public UpdateRowNumbers = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrCell:kEditableTableCell;
            let RowNumber:number = 1;
            let CurrRow:kEditableTableRow;
            for(CurrRow of this.Rows.Items){
                if(CurrRow.RowNumberCell){
                    CurrRow.Index = RowNumber -1;
                    CurrRow.RowNumberCell.textContent = RowNumber.toString();
                    for(CurrCell of CurrRow.Cells){
                        CurrCell.RowIndex = RowNumber -1;
                    }
                }
                RowNumber++;
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.UpdateRowNumbers");
            return;
        }
    }
    public ApplyAlternateRowShading = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (!this.AlternateRowShading) { return; }
            let RowIndex: number = 0;
            for (const CurrRow of this.Rows.Items) {
                const BgColor: string = RowIndex % 2 === 1 ? this.AlternateRowColor : "";
                for (const CurrCell of CurrRow.Cells) {
                    if (CurrCell.Cell.style.backgroundColor !== "" && CurrCell.Cell.style.backgroundColor !== this.AlternateRowColor) {
                        continue;
                    }
                    CurrCell.Cell.style.backgroundColor = BgColor;
                }
                RowIndex++;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.ApplyAlternateRowShading");
        }
    }
    public AddColumn = (Title:string,Type:kHTMLEditableColType,Width:number,PropName:string,DefaultValue?:any,IconImg?:HTMLImageElement): kEditableColumn => {
        if (ks.kErrorMode === true) { return new kEditableColumn(); }
        try {
            const NewCol: kEditableColumn = new kEditableColumn(Title);
            
            NewCol.Title = Title;
            NewCol.Type = Type;
            NewCol.Width = Width;
            NewCol.kObjectPropertyName = PropName;
            if (DefaultValue) {
                NewCol.DefaultValue = DefaultValue;
            }
            NewCol.Icon = IconImg;
            this.Columns.push(NewCol);
            return NewCol;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.AddColumn");
            return new kEditableColumn();
        }
    }
    public KeyDown = (KeyEvent:KeyboardEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let Handled:boolean = false;
            if(KeyEvent.ctrlKey === true && KeyEvent.key === "Control" ||KeyEvent.shiftKey=== true && KeyEvent.key === "Shift"){
                return; //Ignore just the shift and ctrl key events
            }
            if(this.Table !== null && (this.Table as HTMLElement).offsetParent === null){
                return;
            }
            if (kEditableTable._ActiveTable !== this) {
                return;
            }
            if (this.CurrenEditableCell && this.CurrenEditableCell.Cell.contentEditable === "true") {
                if (KeyEvent.key.length === 1) {
                    return;
                }
            }
            if (KeyEvent.ctrlKey === false) {
                if (KeyEvent.shiftKey === false) {
                    Handled = this._HandleNoModifierKey(KeyEvent.key);
                } else { //Shift events
                    Handled = this.ShiftKeyEvents(KeyEvent.key);
                }
            } else { //CTRL key keydown event
                Handled = this.CTRLKeyevents(KeyEvent.key, KeyEvent);
            }
            if(Handled === true){
                KeyEvent.preventDefault();
                KeyEvent.stopPropagation();
                return;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.KeyDown");
            return;
        }
    }
    public ShiftKeyEvents = (key:string):boolean =>{
        let Handled:boolean = false;
        if (ks.kErrorMode === true) { return Handled; }
        try {
            switch (key) {
                case "Tab":
                    if(this.CurrenEditableCell){
                        if (this.CurrenEditableCell.ColumnIndex > 0) {
                            this.CurrenEditableCell.SelectNextLeft();
                        } else {
                            this.CurrenEditableCell.SelectPrevRowLastCell();
                        }
                        Handled = true;
                    } else {
                        const TopLeft: kEditableTableCell | null = this.Selection.GetTopLeftCell();
                        if (TopLeft) { TopLeft.SelectNextLeft(); Handled = true; }
                    }
                    break;
                case "ArrowDown":
                    this.Selection.ExpandDown();
                    break;
                case "ArrowUp":
                    this.Selection.ExpandUp();
                    Handled = true;
                    break;
                case "ArrowRight":
                    this.Selection.ExpandRight();
                    Handled = true;
                    break;
                case "ArrowLeft":
                    this.Selection.ExpandLeft();
                    Handled = true;
                    break;
                case " ":
                    if(this.Selection.SelectionMode === kEdTblSelectionMode.SingleCell){
                        const SelectedCells:kEditableTableCell[] = this.Selection.GetSelectedCells();
                        if(SelectedCells.length ===1){
                            const CurrentRow:kEditableTableRow = this.Rows.Items[SelectedCells[0].RowIndex];
                            if(CurrentRow){
                                this.Selection.SetSingleRowSelected(CurrentRow);
                                Handled = true;
                            }
                        }
                    }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.ShiftKeyEvents");
        }
        return Handled;
    }
    public CTRLKeyevents = (key:string,KeyEvent:KeyboardEvent):boolean =>{
        let Handled:boolean = false;
        if (ks.kErrorMode === true) { return Handled; }
        try {
            if(KeyEvent.shiftKey === true){ //CTRL + SHIFT
                switch (key) {
                    case " ":
                        this.Selection.SelectAll();
                        Handled = true;
                        break;
                    case "End": //CTRL + SHIFT + End
  
                        switch(this.Selection.SelectionMode){
                            case kEdTblSelectionMode.SingleCell:
                            case kEdTblSelectionMode.CustomExtRightDown:
                                this.Selection.ColIndexEnd = this.Columns.Items.length-1;
                                this.Selection.SetSelectionByIndexes(kEdTblSelectionMode.CustomExtRightDown);;
                                Handled = true;
                                break;
                            case kEdTblSelectionMode.CustomExtRightUp:
                                this.Selection.ColIndexEnd = this.Columns.Items.length-1;
                                this.Selection.SetSelectionByIndexes(kEdTblSelectionMode.CustomExtRightUp);
                                Handled = true;
                                break;
                            case kEdTblSelectionMode.CustomExtLeftDown:
                            case kEdTblSelectionMode.CustomExtLeftDown:
                                this.Selection.RowIndexEnd = this.Rows.Items.length -1;
                                this.Selection.ColIndexEnd = this.Columns.Items.length -1;
                                this.Selection.SetSelectionByIndexes(kEdTblSelectionMode.CustomExtRightDown);
                                Handled = true;

                        }
                    break;
                    case "+":
                        this.InsertRowAbove();
                        Handled = true;
                        break;
                }
            }else{
                switch (key) { //CTRL only
                    case " ":
                        if(this.Selection.SelectionMode === kEdTblSelectionMode.SingleCell){
                            const SelectedCells:kEditableTableCell[] = this.Selection.GetSelectedCells();
                            if(SelectedCells.length ===1){
                                const CurrentCol:kEditableColumn = this.Columns.Items[SelectedCells[0].ColumnIndex];
                                if(CurrentCol){
                                    this.Selection.SetSingleColSelected(CurrentCol);
                                    Handled = true;
                                }
                            }
                        }
                        break;
                    case "a":
                        this.Selection.SelectAll()
                        Handled = true;
                        break;
                    case "c":
                        this.CopyClick();
                        Handled = true;
                        break;
                    case "z":
                        this.Undo();
                        Handled = true;
                        break;
                    case "y":
                        this.Redo();
                        Handled = true;
                        break;
                    case "Home":
                        this.GetCellByIndexes(0, 0).Select();
                        Handled = true;
                        break;
                    case "End":
                        this.GetCellByIndexes(this.Rows.Items.length - 1, this.Columns.Items.length - 1).Select();
                        Handled = true;
                        break;
                    case "-":
                        this.RemoveRowContextMenuClick();
                        Handled = true;
                        break;
                    case "d":
                        if(this.Selection.RowIndexEnd > this.Selection.RowIndexStart){
                            this.FillDown();
                        }
                        Handled = true;
                        break;
                    case "r":
                        if(this.Selection.ColIndexEnd > this.Selection.ColindexStart){
                            this.FillRight();
                        }
                        Handled = true;
                        break;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.CTRLKeyevents");
        }
        return Handled;
    }

    private _HandleNoModifierKey = (Key: string): boolean => {
        let Handled: boolean = false;
        if (ks.kErrorMode === true) { return Handled; }
        try {
            switch (Key) {
                case "ArrowDown":
                case "Enter": {
                    if (this.CurrenEditableCell) {
                        this.CurrenEditableCell.SelectNextDown(); Handled = true;
                    } else {
                        const TopLeft: kEditableTableCell | null = this.Selection.GetTopLeftCell();
                        if (TopLeft) { TopLeft.SelectNextDown(); Handled = true; }
                    }
                    break;
                }
                case "ArrowUp": {
                    if (this.CurrenEditableCell) {
                        this.CurrenEditableCell.SelectNextUp(); Handled = true;
                    } else {
                        const TopLeft: kEditableTableCell | null = this.Selection.GetTopLeftCell();
                        if (TopLeft) { TopLeft.SelectNextUp(); Handled = true; }
                    }
                    break;
                }
                case "ArrowLeft": {
                    if (this.CurrenEditableCell) {
                        this.CurrenEditableCell.SelectNextLeft(); Handled = true;
                    } else {
                        const TopLeft: kEditableTableCell | null = this.Selection.GetTopLeftCell();
                        if (TopLeft) { TopLeft.SelectNextLeft(); Handled = true; }
                    }
                    break;
                }
                case "ArrowRight": {
                    if (this.CurrenEditableCell) {
                        this.CurrenEditableCell.SelectNextRight(); Handled = true;
                    } else {
                        const TopRight: kEditableTableCell | null = this.Selection.GetTopRigthCell();
                        if (TopRight) { TopRight.Select(); Handled = true; }
                    }
                    break;
                }
                case " ":
                case "F2": {
                    if (this.CurrenEditableCell && this.CurrenEditableCell.ColDef) {
                        if (this.CurrenEditableCell.ColDef.Type === kHTMLEditableColType.Checkbox || this.CurrenEditableCell.ColDef.Type === kHTMLEditableColType.Radio) {
                            this.CurrenEditableCell.CellClick(); Handled = true;
                        }
                    } else {
                        const TopLeft: kEditableTableCell | null = this.Selection.GetTopLeftCell();
                        if (TopLeft) { TopLeft.Select(); Handled = true; }
                    }
                    break;
                }
                case "Tab": {
                    if (this.CurrenEditableCell) {
                        if ((this.CurrenEditableCell.ColumnIndex + 1) < this.Columns.Items.length) {
                            this.CurrenEditableCell.SelectNextRight();
                        } else {
                            this.CurrenEditableCell.SelectNextRowFirstCell();
                        }
                        Handled = true;
                    } else {
                        const TopRight: kEditableTableCell | null = this.Selection.GetTopRigthCell();
                        if (TopRight) { TopRight.Select(); Handled = true; }
                    }
                    break;
                }
                case "Delete": {
                    if (this.CurrenEditableCell) {
                        const _DelRow = this.Rows.Items[this.CurrenEditableCell.RowIndex];
                        if (!_DelRow || !_DelRow.ReadOnly) {
                            this.CurrenEditableCell.SetNewValue("", true);
                        }
                        Handled = true;
                    }
                    break;
                }
                case "End": {
                    if (this.Selection.SelectionMode === kEdTblSelectionMode.SingleCell) {
                        this.Selection.SelectLastCell(); Handled = true;
                    }
                    break;
                }
                case "Home": {
                    if (this.Selection.SelectionMode === kEdTblSelectionMode.SingleCell) {
                        this.Selection.SelectFirstCell(); Handled = true;
                    }
                    break;
                }
                default:
                    break;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._HandleNoModifierKey");
        }
        return Handled;
    }

    private _prevSelectionUnique:number =0;
    public CheckSelectionChange = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Table !== null && (this.Table as HTMLElement).offsetParent === null){
                return;
            }
            if(this.CurrenEditableCell){
                if(this.CurrenEditableCell.UniqueID !== this._prevSelectionUnique){
                    this._prevSelectionUnique = this.CurrenEditableCell.UniqueID;
                    if(this.CellSelectionChangedCB){
                        this.CellSelectionChangedCB(this.CurrenEditableCell);
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.CheckSelectionChange");
            return;
        }
    }
    public SetParentSize = (Height:number): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.Table) {
                const ParentElement: HTMLElement | null = this.Table.parentElement;
                if (ParentElement) {
                    ParentElement.style.width = this.Table.clientWidth + 40 + "px";
                    ParentElement.style.height = Height + "px";
                    ParentElement.style.overflowY = "scroll";
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SetParentSize");
            return;
        }
    }
    public AddStyles = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            const ExistingStyle = document.getElementById("kEditableTableStyles");
            if (ExistingStyle === null) {
                const Style: HTMLStyleElement = document.createElement("style");
                Style.id = "kEditableTableStyles";
                Style.innerHTML = `
                  .kEditableTable {
                      border: 1px solid #d1d1d1 !important;
                      font-size: 9pt !important;
                      font-family: 'Segoe UI', 'Aptos Narrow', sans-serif !important;
                      border-spacing: 0 !important;
                      border-collapse: collapse !important;
                      float: left;
                      white-space: nowrap !important;
                  }
                  .kEditableTable th {
                      background-color: #f2f2f2 !important;
                      border: 0 !important;
                      border-bottom: 1px solid #c8c8c8 !important;
                      border-right: 1px solid #d1d1d1 !important;
                      font-weight: 600 !important;
                      font-size: 9pt !important;
                      color: #323130 !important;
                      padding: 2px 6px !important;
                      white-space: nowrap !important;
                      vertical-align: middle !important;
                      user-select: none;
                      position: sticky;
                      top: 0;
                      z-index: 2;
                  }
                  .kEditableTableRow {
                      display: table-row;
                      background: transparent !important;
                      border: 0 !important;
                      padding: 0 !important;
                      margin: 0 !important;
                      height: auto !important;
                  }
                  .kRowNumberHeading {
                      background-color: #f2f2f2 !important;
                      border: 0 !important;
                      border-bottom: 1px solid #c8c8c8 !important;
                      border-right: 1px solid #d1d1d1 !important;
                      font-weight: 400 !important;
                      font-size: 9pt !important;
                      text-align: center !important;
                      user-select: none;
                      color: #666666 !important;
                      white-space: nowrap !important;
                      vertical-align: middle !important;
                      width: 8px;
                      position: sticky;
                      top: 0;
                      left: 0;
                      z-index: 1;
                  }
                  .kEditableTableCell {
                      background-color: white !important;
                      padding: 1px 6px !important;
                      border-bottom: 1px solid #e8e8e8 !important;
                      border-right: 1px solid #e8e8e8 !important;
                      height: 20px !important;
                      font-size: 9pt !important;
                      font-weight: normal !important;
                      color: #323130 !important;
                      white-space: nowrap !important;
                      vertical-align: middle !important;
                      line-height: normal !important;
                      user-select: none;
                      position: relative;
                  }
                  .kValidationIcon {
                      position: absolute;
                      right: 2px;
                      top: 1px;
                      color: #d13438;
                      font-size: 10px;
                      pointer-events: none;
                      line-height: 1;
                  }
                  .kEditableTableCell:hover:not(.SelectedCellSingle):not(.SelectedCellMulti):not(.SelectedFirstRow) {
                      background-color: #f5f5f5 !important;
                  }
                  td.SelectedCellSingle {
                      background-color: #cce5ff !important;
                      outline: 1px solid #0078d4 !important;
                      outline-offset: -1px;
                  }
                  td.SelectedCellMulti {
                      background-color: #daeeff !important;
                  }
                  td.SelectedFirstRow {
                      background-color: #b3d7ff !important;
                  }
                  .kEditableTableCell .highlighted {
                      background-color: #8a8886;
                  }
                  .kEditableTableCell .heading {
                      background-color: #f2f2f2;
                      border-bottom: 1px solid #c8c8c8;
                      border-right: 1px solid #d1d1d1;
                      text-align: center;
                      padding: 0;
                      user-select: none;
                  }
                  .kEditableTableCell select,
                  .kEditableTableCell input[type="text"],
                  .kEditableTableCell input[type="number"],
                  .kEditableTableCell input[type="date"] {
                      height: 20px;
                      box-sizing: border-box;
                      border: none;
                      padding: 0 4px;
                      font-family: inherit;
                      font-size: inherit;
                      color: inherit;
                      background: transparent;
                      outline: none;
                      width: 100%;
                  }
                  .kEditableTableCell:has(select),
                  .kEditableTableCell:has(input) {
                      padding: 0;
                  }
                  .kEditableTableRowReadOnly td {
                      background-color: #f5f5f5 !important;
                      color: #a0a0a0 !important;
                      cursor: default !important;
                      font-style: italic !important;
                  }
                  .kEditableTableRowReadOnly td:hover:not(.SelectedCellSingle):not(.SelectedCellMulti) {
                      background-color: #f5f5f5 !important;
                  }
                  `
                document.head.appendChild(Style);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.AddStyles");
            return;
        }
    }

    public RemoveContentRows = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            for (const CurrRow of this.Rows.Items) {
                if (CurrRow.Row) { CurrRow.Row.remove(); }
            }
            this.Rows.Items = [];
            this.Selection.ClearPrev();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.RemoveContentRows");
            return;
        }
    }
    // public ContentToCollection = (ItemObject:any,ArrayObject?:any): any => {
    //     if (ks.kErrorMode === true) { return; }
    //     try {
    //         let CollectionItem: kObject = new ItemObject();; 
    //         let CurrRow: kEditableTableRow;
    //         let CurrCell: kEditableTableCell;
    //         let RowIndex: number = 0;
    //         //this.ClearSelection();
    //         if (this.CurrenEditableCell) {
    //             this.CurrenEditableCell.SetCellReadMode();
    //         }
    //         if (this.RowValues === null) {
    //             if (ArrayObject) {
    //                 this.RowValues = new ArrayObject();
    //             } else {
    //                 this.RowValues = new kObjectArray()
    //             }
    //         }
    //         if (this.RowValues) { 
    //             for (CurrRow of this.Rows.Items) {
    //                 if(CurrRow.IsEmppty() === false){
    //                     CollectionItem = this.RowValues.GetItemByUniqueID(CurrRow.UniqueID);
    //                     if (CollectionItem) {
    //                         CollectionItem.Index = RowIndex;
    //                     } else {
    //                         //New items added
    //                         CollectionItem = new ItemObject();
    //                         this.RowValues.push(CollectionItem); 
    //                         CurrRow.UniqueID = CollectionItem.UniqueID;
    //                     }
    //                         for (CurrCell of CurrRow.Cells) {
    //                             if (CurrCell.ColDef) {
    //                                 switch (CurrCell.ColDef.Type) {
    //                                     case kHTMLEditableColType.Checkbox:
    //                                         CollectionItem[CurrCell.ColDef.kObjectPropertyName] = CurrCell.Cell.textContent === "☑";
    //                                         break;
    //                                     case kHTMLEditableColType.Radio:
    //                                         CollectionItem[CurrCell.ColDef.kObjectPropertyName] = CurrCell.Cell.textContent === "⚫";
    //                                         break;
    //                                     case kHTMLEditableColType.Color:
    //                                         CollectionItem[CurrCell.ColDef.kObjectPropertyName] = CurrCell.Cell.style.backgroundColor;
    //                                         break;
    //                                     case kHTMLEditableColType.Date:
    //                                         CollectionItem[CurrCell.ColDef.kObjectPropertyName] = CurrCell.CurrentValue;
    //                                         break;
    //                                     case kHTMLEditableColType.Number:
    //                                         CollectionItem[CurrCell.ColDef.kObjectPropertyName] = ks.n0(CurrCell.CurrentValue);
    //                                     case kHTMLEditableColType.Currency:
    //                                         CollectionItem[CurrCell.ColDef.kObjectPropertyName] = ks.NumberFromCurrency(CurrCell.CurrentValue);
    //                                         break;
    //                                     default:
    //                                         if (CurrCell.Cell.textContent) {
    //                                             CollectionItem[CurrCell.ColDef.kObjectPropertyName] = CurrCell.Cell.textContent.trim();
    //                                         } else {
    //                                             CollectionItem[CurrCell.ColDef.kObjectPropertyName] = "";
    //                                         }
    //                                 }
    //                             }
    //                         }
    //                         RowIndex++;
    //                         //Existing items will be updated in the collection
    //                 }
    //             }
    //             for (CollectionItem of this.RowValues.Items) {
    //                 CurrRow = this.Rows.GetItemByUniqueID(CollectionItem.UniqueID);
    //                 if (CurrRow === null) {
    //                     this.RowValues.RemoveItemByUniqueID(CollectionItem.UniqueID);
    //                 }
    //             }
    //         }
    //         return this.RowValues;
    //     } catch (e) {
    //         ks.kGlobalErrorHandler(e, "kEditableTable.ContentToCollection");
    //         return;
    //     }
    // }
    public GetGridContentsTokObjectArray = (NewItemObject:any,NewArrayObject:any):any =>{
        const ResultArray:kObjectArray = new NewArrayObject();
        if (ks.kErrorMode === true) { return ResultArray; }
        try {
            if(this.CurrenEditableCell){
                this.CurrenEditableCell.SetCellReadMode();
            }
            for(const CurrRow of this.Rows.Items){
                if(CurrRow.IsEmpty() === false){
                    const NewItem:kObject = new NewItemObject(CurrRow.GetValueFromCell("Title"));
                    ResultArray.push(NewItem);
                    for(const CurrCell of CurrRow.Cells){
                        if (CurrCell.ColDef) {
                            NewItem[CurrCell.ColDef.kObjectPropertyName] = this._ConvertCellValue(CurrCell, CurrCell.ColDef);
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.GetGridContentsTokObjectArray");
        }
        return ResultArray;
    }

    private _ConvertCellValue = (CurrCell: kEditableTableCell, ColDef: kEditableColumn): any => {
        if (ks.kErrorMode === true) { return ""; }
        try {
            switch (ColDef.Type) {
                case kHTMLEditableColType.Checkbox:
                    return CurrCell.Cell.textContent === "☑";
                case kHTMLEditableColType.Radio:
                    return CurrCell.CurrentValue === true;
                case kHTMLEditableColType.Color:
                    return CurrCell.Cell.style.backgroundColor;
                case kHTMLEditableColType.Date:
                    return CurrCell.CurrentValue;
                case kHTMLEditableColType.Number:
                case kHTMLEditableColType.Currency:
                    return ks.n0(CurrCell.CurrentValue);
                default:
                    if (CurrCell.Cell.textContent) {
                        return CurrCell.Cell.textContent.trim();
                    }
                    return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._ConvertCellValue");
            return "";
        }
    }
    public AddContentRows = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrRowIndex: number = 0;
            let CurrColIndex: number = 0;
            let CurrItem: kObject;
            let CurrCol: kEditableColumn;
            this.Rows.Items = [];
            if (this.RowValues && this.Table) {
                for (CurrItem of this.RowValues.Items) {
                    const NewRow: kEditableTableRow = new kEditableTableRow(CurrRowIndex);
                    NewRow.UniqueID = CurrItem.UniqueID;
                    NewRow.ID = CurrItem.ID;
                    NewRow.ParentTable = this;
                    CurrColIndex = 0;
                    for (CurrCol of this.Columns.Items) {
                        NewRow.AddCell(this._CreateContentCell(CurrItem, CurrCol, CurrRowIndex, CurrColIndex));
                        CurrColIndex++;
                    }
                    if (NewRow.Row) { this.Table.appendChild(NewRow.Row); }
                    this.Rows.push(NewRow);
                    CurrRowIndex++;
                }
            }
            if (this.AddBlankRows === true) {
                this.AddEmptyRows(1);
            }
            this.ApplyAlternateRowShading();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.AddContentRows");
            return;
        }
    }

    private _CreateContentCell = (CurrItem: kObject, CurrCol: kEditableColumn, CurrRowIndex: number, CurrColIndex: number): kEditableTableCell => {
        if (ks.kErrorMode === true) { return new kEditableTableCell(); }
        try {
            const NewCell: kEditableTableCell = new kEditableTableCell();
            NewCell.RowIndex = CurrRowIndex;
            NewCell.ColumnIndex = CurrColIndex;
            NewCell.Title = "Cell r" + CurrRowIndex.toString() + " c" + CurrColIndex.toString();
            NewCell.ColDef = CurrCol;
            switch (NewCell.ColDef.Type) {
                case kHTMLEditableColType.Number:
                case kHTMLEditableColType.Currency:
                    NewCell.Cell.style.textAlign = "right";
                    NewCell.OrgValue = 0;
                    NewCell.Cell.textContent = NewCell.ColDef.Type === kHTMLEditableColType.Number ? "0" : ks.LocalCurrencyNumber(0);
                    break;
                default:
                    break;
            }
            NewCell.ParentTable = this;
            switch (CurrCol.Type) {
                case kHTMLEditableColType.Date: {
                    const CurrDate: kTime | null = CurrItem[CurrCol.kObjectPropertyName];
                    if (CurrDate) { NewCell.SetCellOrgValue(CurrDate); }
                    break;
                }
                case kHTMLEditableColType.SelectMulti:
                    NewCell.SetCellOrgValue(CurrItem[CurrCol.kObjectPropertyName].join("; "));
                    break;
                default:
                    NewCell.SetCellOrgValue(CurrItem[CurrCol.kObjectPropertyName]);
                    break;
            }
            if (CurrCol.Width === 0) { NewCell.Cell.style.display = "none"; }
            if (CurrCol._FrozenLeft >= 0) {
                NewCell.Cell.style.position = "sticky";
                NewCell.Cell.style.left = CurrCol._FrozenLeft + "px";
                NewCell.Cell.style.zIndex = "1";
                NewCell.Cell.style.background = "inherit";
            }
            return NewCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._CreateContentCell");
            return new kEditableTableCell();
        }
    }
    public ToTable = (): HTMLTableElement => {
        if (ks.kErrorMode === true) { return document.createElement("table"); }
        try {
            this.AddStyles();
            this.SetupRowContextMenu();
            this.SetupColContextMenu();
            this.SetupRangeContextMenu();
            this.Table = document.createElement("table");
            this.Table.className = "kEditableTable";
            this.Table.setAttribute("role", "grid");
            const RowNumberHeading:kEditableTableHeading = new kEditableTableHeading("",false,null);
            if(RowNumberHeading && RowNumberHeading.HeaderCell){
                RowNumberHeading.Sortable = false;
                RowNumberHeading.HeaderCell.setAttribute("role", "columnheader");
                this.Table.appendChild(RowNumberHeading.HeaderCell);
                RowNumberHeading.HeaderCell.style.borderRight = "thin solid grey";
                RowNumberHeading.HeaderCell.addEventListener("click",this.Selection.SelectAll);
                if(this.RowContextMenu){
                    RowNumberHeading.HeaderCell.addEventListener("contextmenu",this.RowContextMenu.ShowMenu);
                }
            }
            this._CreateColumnHeaders();
            if(this.RowValues){
                this.AddContentRows();
            }else{
                this.AddEmptyRows(10);
            }
            document.addEventListener("keydown", this.KeyDown);
            this.Table.addEventListener("paste", this.PasteHandler);
            this.Table.addEventListener("mouseenter", this.MouseEnter);
            return this.Table;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.ToTable");
            return document.createElement("table");
        }
    }

    private _CreateColumnHeaders = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.Headers = [];
            let FrozenLeftOffset: number = 30;
            for(const CurrCol of this.Columns.Items){
                const NewHeader:kEditableTableHeading = new kEditableTableHeading(CurrCol.Title,true,CurrCol.Icon);
                if(NewHeader && NewHeader.HeaderCell){
                    NewHeader.ParentTable = this;
                    NewHeader.ColumnIndex = this.Headers.length;
                    NewHeader.HeaderCell.setAttribute("role", "columnheader");
                    if(CurrCol.Width > 0){
                        NewHeader.HeaderCell.style.width = CurrCol.Width.toString() + "px";
                        NewHeader.HeaderCell.style.minWidth = CurrCol.Width.toString() + "px";
                    }else{
                        NewHeader.HeaderCell.style.display = "none";
                    }
                    if (CurrCol.Frozen && CurrCol.Width > 0) {
                        CurrCol._FrozenLeft = FrozenLeftOffset;
                        NewHeader.HeaderCell.style.position = "sticky";
                        NewHeader.HeaderCell.style.left = FrozenLeftOffset + "px";
                        NewHeader.HeaderCell.style.zIndex = "3";
                        FrozenLeftOffset += CurrCol.Width;
                    }
                    this.Table.appendChild(NewHeader.HeaderCell);
                    this.Headers.push(NewHeader);
                    if (CurrCol.Resizable) {
                        this._AddResizeHandle(NewHeader);
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._CreateColumnHeaders");
        }
    }
    public MouseEnter = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.Table !== null && (this.Table as HTMLElement).offsetParent === null){
                return;
            }
            if(this.Table){
                this.Table.focus();
            }
            kEditableTable.SetActiveTable(this);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.MouseEnter");
            return ;
        }
    }

    public SortByColumn = (ColumnIndex:number): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.Headers.length > ColumnIndex){
                const CurrHeader:kEditableTableHeading = this.Headers[ColumnIndex];
                if(CurrHeader){
                    if(CurrHeader.Sorted === false){
                        this.SortAscending(ColumnIndex);
                    }else{
                        if(CurrHeader.SortedAscending === true){
                            this.SortDescending(ColumnIndex);
                        }else{
                            this.SortAscending(ColumnIndex);
                        }
                    }
                }
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SortByColumn");
            return ;
        }
    }
    public SortAscending = (ColumnIndex?:number): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(ColumnIndex === undefined){
                if(this.RightClickColumn){
                    ColumnIndex = this.RightClickColumn.ColumnIndex;
                }else{
                    ColumnIndex = 0;
                }
            }
            if(this.Headers.length > ColumnIndex){
                const CurrHeader:kEditableTableHeading = this.Headers[ColumnIndex];
                if(CurrHeader && CurrHeader.SortButton){
                    CurrHeader.SortedAscending = true;
                    CurrHeader.Sorted = true;
                    CurrHeader.SortButton.innerHTML = "&#8595;";
                    CurrHeader.SortButton.style.fontWeight = "bold";
                    CurrHeader.SortButton.style.color = "#0078d4";
                    this.SortTable(ColumnIndex,true);
                    if (this.OnSorted !== null) { this.OnSorted(ColumnIndex, true); }
                }
                this._SetOtherUnsorted(ColumnIndex);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SortAscending");
            return ;
        }
    }
    public SortDescending = (ColumnIndex?:number): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(ColumnIndex === undefined){
                if(this.RightClickColumn){
                    ColumnIndex = this.RightClickColumn.ColumnIndex;
                }else{
                    ColumnIndex = 0;
                }
            }
            if(this.Headers.length > ColumnIndex){
                const CurrHeader:kEditableTableHeading = this.Headers[ColumnIndex];
                if(CurrHeader && CurrHeader.SortButton){
                    CurrHeader.SortedAscending = false;
                    CurrHeader.Sorted = true;
                    CurrHeader.SortButton.innerHTML = "&#8593;";
                    CurrHeader.SortButton.style.color = "#0078d4";
                    this.SortTable(ColumnIndex,false);
                    if (this.OnSorted !== null) { this.OnSorted(ColumnIndex, false); }
                    // if(this.RowValues){
                    //     this.RowValues.SortByProperty(this.Columns[CurrHeader.ColumnIndex].kObjectPropertyName,false);
                    // }
                    // this.RemoveContentRows();
                    // this.AddContentRows();   
                }

                this._SetOtherUnsorted(ColumnIndex);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SortDescending");
            return ;
        }   
    }
    private _GetSortableValue = (Cell: kEditableTableCell): any => {
        if (ks.kErrorMode === true) { return null; }
        try {
            const Val: any = Cell.CurrentValue;
            if (Val && typeof Val === "object" && typeof Val.ToISODate === "function") {
                return Val.ToISODate();
            }
            return Val;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._GetSortableValue");
            return null;
        }
    }

    private _SortColumnIndex: number = 0;
    private _SortAscending: boolean = true;

    private _RowComparator = (A: kEditableTableRow, B: kEditableTableRow): number => {
        const ValA: any = this._GetSortableValue(A.Cells[this._SortColumnIndex]);
        const ValB: any = this._GetSortableValue(B.Cells[this._SortColumnIndex]);
        if (ValA === ValB) { return 0; }
        if (ValA === null || ValA === undefined) { return this._SortAscending ? -1 : 1; }
        if (ValB === null || ValB === undefined) { return this._SortAscending ? 1 : -1; }
        return this._SortAscending ? (ValA > ValB ? 1 : -1) : (ValA < ValB ? 1 : -1);
    }

    public SortTable = (ColumnIndex: number, Ascending: boolean): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this._SortColumnIndex = ColumnIndex;
            this._SortAscending = Ascending;
            const DataRows: kEditableTableRow[] = [];
            const EmptyRows: kEditableTableRow[] = [];
            let CurrRow: kEditableTableRow;
            for (CurrRow of this.Rows.Items) {
                if (CurrRow.IsEmpty()) {
                    EmptyRows.push(CurrRow);
                } else {
                    DataRows.push(CurrRow);
                }
            }
            DataRows.sort(this._RowComparator);
            this.Rows.Items = [...DataRows, ...EmptyRows];
            const Frag: DocumentFragment = document.createDocumentFragment();
            for (CurrRow of this.Rows.Items) {
                if (CurrRow.Row) {
                    Frag.appendChild(CurrRow.Row);
                }
            }
            this.Table.appendChild(Frag);
            this.UpdateRowNumbers();
            this.ApplyAlternateRowShading();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SortTable");
            return;
        }
    }

    private _SetOtherUnsorted = (ColumnIndex:number): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.Headers.length > ColumnIndex){
                for(const CurrHeader of this.Headers){
                    if(CurrHeader !== this.Headers[ColumnIndex]){
                        CurrHeader.SetUnsorted();
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._SetOtherUnsorted");
            return ;
        }
    }

    // Column resizing
    private _ResizingHeader: kEditableTableHeading | null = null;
    private _ResizeStartX: number = 0;
    private _ResizeStartWidth: number = 0;

    private _AddResizeHandle = (Header: kEditableTableHeading): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (Header.HeaderCell === null) { return; }
            Header.HeaderCell.style.position = "relative";
            const Handle: HTMLDivElement = document.createElement("div");
            Handle.style.cssText = "position:absolute;right:0;top:0;bottom:0;width:5px;cursor:col-resize;user-select:none;";
            (Handle as any)._header = Header;
            Handle.addEventListener("mousedown", this._OnResizeMouseDown);
            Header.HeaderCell.appendChild(Handle);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._AddResizeHandle");
        }
    }

    private _OnResizeMouseDown = (Event: MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const Handle: HTMLDivElement = Event.currentTarget as HTMLDivElement;
            this._ResizingHeader = (Handle as any)._header as kEditableTableHeading;
            this._ResizeStartX = Event.clientX;
            this._ResizeStartWidth = this._ResizingHeader.HeaderCell ? this._ResizingHeader.HeaderCell.offsetWidth : 0;
            document.addEventListener("mousemove", this._OnResizeMouseMove);
            document.addEventListener("mouseup", this._OnResizeMouseUp);
            Event.preventDefault();
            Event.stopPropagation();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._OnResizeMouseDown");
        }
    }

    private _OnResizeMouseMove = (Event: MouseEvent): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this._ResizingHeader === null || this._ResizingHeader.HeaderCell === null) { return; }
            const Delta: number = Event.clientX - this._ResizeStartX;
            const NewWidth: number = Math.max(30, this._ResizeStartWidth + Delta);
            this._ResizingHeader.HeaderCell.style.width = NewWidth + "px";
            this._ResizingHeader.HeaderCell.style.minWidth = NewWidth + "px";
            if (this._ResizingHeader.ColumnIndex < this.Columns.Items.length) {
                this.Columns.Items[this._ResizingHeader.ColumnIndex].Width = NewWidth;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._OnResizeMouseMove");
        }
    }

    private _OnResizeMouseUp = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this._ResizingHeader = null;
            document.removeEventListener("mousemove", this._OnResizeMouseMove);
            document.removeEventListener("mouseup", this._OnResizeMouseUp);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._OnResizeMouseUp");
        }
    }

    // Virtual scrolling
    public VirtualScrollMaxHeight: number = 0;
    private _ScrollWrapper: HTMLDivElement | null = null;
    private _RowObserver: IntersectionObserver | null = null;

    public WrapInScrollContainer = (): HTMLDivElement => {
        if (ks.kErrorMode === true) { return document.createElement("div"); }
        try {
            this._ScrollWrapper = document.createElement("div");
            this._ScrollWrapper.className = "kEditableTableWrapper";
            this._ScrollWrapper.style.overflowX = "auto";
            if (this.VirtualScrollMaxHeight > 0) {
                this._ScrollWrapper.style.maxHeight = this.VirtualScrollMaxHeight + "px";
                this._ScrollWrapper.style.overflowY = "auto";
            }
            this._ScrollWrapper.appendChild(this.Table);
            return this._ScrollWrapper;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.WrapInScrollContainer");
            return document.createElement("div");
        }
    }

    public SetVirtualScrollHeight = (HeightPx: number): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.VirtualScrollMaxHeight = HeightPx;
            if (this._ScrollWrapper) {
                this._ScrollWrapper.style.maxHeight = HeightPx + "px";
                this._ScrollWrapper.style.overflowY = "auto";
            }
            this._SetupIntersectionObserver();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SetVirtualScrollHeight");
        }
    }

    private _SetupIntersectionObserver = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.VirtualScrollMaxHeight === 0 || this._ScrollWrapper === null) { return; }
            if (this._RowObserver) { this._RowObserver.disconnect(); }
            this._RowObserver = new IntersectionObserver(this._OnRowVisibilityChange, {
                root: this._ScrollWrapper,
                rootMargin: "200px 0px",
                threshold: 0
            });
            let CurrRow: kEditableTableRow;
            for (CurrRow of this.Rows.Items) {
                if (CurrRow.Row) {
                    this._RowObserver.observe(CurrRow.Row);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._SetupIntersectionObserver");
        }
    }

    private _OnRowVisibilityChange = (Entries: IntersectionObserverEntry[]): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let Entry: IntersectionObserverEntry;
            for (Entry of Entries) {
                const Row: HTMLTableRowElement = Entry.target as HTMLTableRowElement;
                Row.style.visibility = Entry.isIntersecting ? "visible" : "hidden";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._OnRowVisibilityChange");
        }
    }
    public AddEmptyRows = (NumberOfRows:number): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            let Counter: number = 0;
            let CurrRowIndex: number = this.Rows.Items.length;
            let CurrColIndex: number = 0;
            let CurrCol:kEditableColumn;
            if(this.Table){
                for (Counter =0; Counter < NumberOfRows;Counter++) {
                    const NewRow: kEditableTableRow = new kEditableTableRow(CurrRowIndex);
                    NewRow.ParentTable = this;
                    if(NewRow.Row){
                        CurrColIndex = 0;
                        for(CurrCol of this.Columns.Items){
                            const NewCell: kEditableTableCell = new kEditableTableCell();
                            NewCell.RowIndex = CurrRowIndex;
                            NewCell.ColumnIndex = CurrColIndex;    
                            NewCell.ColDef = CurrCol;
                            switch (CurrCol.Type){
                                case kHTMLEditableColType.Number:
                                    NewCell.Cell.style.textAlign = "right";
                                    NewCell.Cell.textContent = "0";
                                    break;
                                case kHTMLEditableColType.Currency:
                                    NewCell.Cell.style.textAlign = "right";
                                    NewCell.Cell.textContent = ks.LocalCurrencyNumber(0);
                                    break;
                                case kHTMLEditableColType.Checkbox:
                                    NewCell.Cell.style.textAlign = "center";
                                    NewCell.Cell.textContent = "☐"
                                    break;
                                case kHTMLEditableColType.Radio:
                                    NewCell.Cell.style.textAlign = "center";
                                    NewCell.Cell.innerHTML = NewCell._RadioHtml(false);
                                    break;
                            }
                            NewCell.ParentTable = this;
                            if (CurrCol.DefaultValue) {
                                NewCell.SetCellOrgValue(CurrCol.DefaultValue);
                            } else {
                                NewCell.OrgValue = "";
                            }
                            if(CurrCol.Width === 0){
                                NewCell.Cell.style.display = "none";
                            }
                            if (CurrCol._FrozenLeft >= 0) {
                                NewCell.Cell.style.position = "sticky";
                                NewCell.Cell.style.left = CurrCol._FrozenLeft + "px";
                                NewCell.Cell.style.zIndex = "1";
                                NewCell.Cell.style.background = "inherit";
                            }
                            NewRow.AddCell(NewCell);
                            CurrColIndex++;
                        }
                        this.Table.appendChild(NewRow.Row);
                        this.Rows.push(NewRow);
                        CurrRowIndex++;
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.AddEmptyRows");
            return ;
        }
    }

    public InsertRowAbove = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (!this.Table || this.Rows.Items.length === 0) { return; }
            const InsertIdx: number = this.Selection.RowIndexStart;
            const NewRow: kEditableTableRow = new kEditableTableRow(InsertIdx);
            NewRow.ParentTable = this;
            if (!NewRow.Row) { return; }
            let CurrColIndex: number = 0;
            let CurrCol: kEditableColumn;
            for (CurrCol of this.Columns.Items) {
                const NewCell: kEditableTableCell = new kEditableTableCell();
                NewCell.RowIndex = InsertIdx;
                NewCell.ColumnIndex = CurrColIndex;
                NewCell.ColDef = CurrCol;
                NewCell.ParentTable = this;
                switch (CurrCol.Type) {
                    case kHTMLEditableColType.Number:
                        NewCell.Cell.style.textAlign = "right";
                        NewCell.Cell.textContent = "0";
                        break;
                    case kHTMLEditableColType.Currency:
                        NewCell.Cell.style.textAlign = "right";
                        NewCell.Cell.textContent = ks.LocalCurrencyNumber(0);
                        break;
                    case kHTMLEditableColType.Checkbox:
                        NewCell.Cell.style.textAlign = "center";
                        NewCell.Cell.textContent = "☐";
                        break;
                    case kHTMLEditableColType.Radio:
                        NewCell.Cell.style.textAlign = "center";
                        NewCell.Cell.innerHTML = NewCell._RadioHtml(false);
                        break;
                }
                if (CurrCol.DefaultValue) {
                    NewCell.SetCellOrgValue(CurrCol.DefaultValue);
                } else {
                    NewCell.OrgValue = "";
                }
                if (CurrCol.Width === 0) { NewCell.Cell.style.display = "none"; }
                if (CurrCol._FrozenLeft >= 0) {
                    NewCell.Cell.style.position = "sticky";
                    NewCell.Cell.style.left = CurrCol._FrozenLeft + "px";
                    NewCell.Cell.style.zIndex = "1";
                    NewCell.Cell.style.background = "inherit";
                }
                NewRow.AddCell(NewCell);
                CurrColIndex++;
            }
            const RefRow: kEditableTableRow = this.Rows.Items[InsertIdx];
            this.Table.insertBefore(NewRow.Row, RefRow.Row);
            this.Rows.Items.splice(InsertIdx, 0, NewRow);
            this.UpdateRowNumbers();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.InsertRowAbove");
        }
    }

    public GetCellByIndexes = (RowIndex:number,ColIndex:number): kEditableTableCell => {
        if (ks.kErrorMode === true) { return new kEditableTableCell ; }
        try {
            let CurrRow:kEditableTableRow;
            let CurrCell:kEditableTableCell = new kEditableTableCell();
            if(RowIndex >= this.Rows.Items.length){
                if(this.AddBlankRows === true){
                    this.AddEmptyRows(1);
                } else {
                    return CurrCell;
                }
            }

            if(RowIndex>=0){
                CurrRow = this.Rows.Items[RowIndex];
                if(ColIndex < CurrRow.Cells.length && ColIndex >= 0){
                    CurrCell = CurrRow.Cells[ColIndex];
                }   
            }
            return CurrCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.GetCellByIndexes");
            return  new kEditableTableCell;
        }
    } 
    public PasteHandler = (Event:ClipboardEvent): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if (!this.CurrenEditableCell) {
                const TopLeft: kEditableTableCell | null = this.Selection.GetTopLeftCell();
                if (TopLeft) { this.CurrenEditableCell = TopLeft; }
            }
            if(this.CurrenEditableCell){
                this._AddPasted();
                Event.stopPropagation();
                Event.preventDefault();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.PasteHandler");
            return ;
        }
    }
    public RightClickPaste = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            this.CurrenEditableCell = this.RightClickCell;
            this._AddPasted();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.PasteHandler");
            return ;
        }
    }

    private _AddPasted = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if (!this.CurrenEditableCell) { return; }
            this.Table.focus();
            (navigator as any).clipboard.readText()
                .then((text: any) => {
                    if (!this.CurrenEditableCell) { return; }
                    this.PasteInProgress = true;
                    const Lines: string[] = text.split('\n');
                    if (Lines.length > 1) {
                        this._PasteMultiCell(Lines);
                    } else {
                        this.CurrenEditableCell.SetNewValue(text);
                    }
                    this.PasteInProgress = false;
                    ks.DoCallBack(this.CellDirtiedCB, this.CurrenEditableCell, false);
                })
                .catch((err: any) => {
                    this.PasteInProgress = false;
                    console.error('Failed to read clipboard contents: ', err);
                });
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._AddPasted");
            return ;
        }
    }

    private _PasteMultiCell = (Lines: string[]): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (!this.CurrenEditableCell) { return; }
            const RowsBelow: number = this.Rows.Items.length - this.CurrenEditableCell.RowIndex + 1;
            if (RowsBelow < Lines.length) {
                this.AddEmptyRows(Lines.length - RowsBelow);
            }
            let CurrRowIndex: number = this.CurrenEditableCell.RowIndex;
            let CurrColIndex: number = this.CurrenEditableCell.ColumnIndex;
            for (let i: number = 0; i < Lines.length; i++) {
                const CurrRowValues: string[] = Lines[i].split('\t');
                if (CurrRowValues.length > 0) {
                    if (CurrRowIndex < this.Rows.Items.length && this.Rows.Items[CurrRowIndex].ReadOnly) {
                        CurrRowIndex++;
                        CurrColIndex = this.CurrenEditableCell.ColumnIndex;
                        continue;
                    }
                    for (let j: number = 0; j < CurrRowValues.length; j++) {
                        if (CurrRowIndex < this.Rows.Items.length) {
                            const CurrRow: kEditableTableRow = this.Rows.Items[CurrRowIndex];
                            if (CurrColIndex < CurrRow.Cells.length) {
                                CurrRow.Cells[CurrColIndex].SetNewValue(CurrRowValues[j].trim());
                                CurrColIndex++;
                            }
                        }
                    }
                    CurrRowIndex++;
                    CurrColIndex = this.CurrenEditableCell.ColumnIndex;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._PasteMultiCell");
        }
    }

    public SetupRowContextMenu = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            this.RowContextMenu = new kContextMenu();
            this.RowContextMenu.AddMenuItem(LNG.COPY,this.CopyClick,kFluentIcons.Copy().ToURLEncoded());
            this.RowContextMenu.AddMenuItem(LNG.REMOVE,this.RemoveRowContextMenuClick,kFluentIcons.Delete().ToURLEncoded());
            this.RowContextMenu.AddMenuItem("Export till Excel",this.ExportToExcel);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SetupRowContextMenu");
            return ;
        }
    }
    public ExportToExcel = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const Exporter: kExcelExport = new kExcelExport();
            Exporter.ExportTable(this, "Export");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.ExportToExcel");
        }
    }
    public SetupColContextMenu = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
           
            this.ColContextMenu = new kContextMenu();
            this.ColContextMenu.AddMenuItem("↓  "+ LNG.SORTCOLUMNASC,this.RightClickSortAscending);
            this.ColContextMenu.AddMenuItem("↑  " +LNG.SORTCOLUMNDESC,this.RightClickSortDecending);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SetupColContextMenu");
            return ;
        }
    }
    public RightClickSortAscending = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
           if(this.RightClickColumn){
                this.SortAscending(this.RightClickColumn.ColumnIndex);
           }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.RightClickSortAscending");
            return ;
        }
    }
    public RightClickSortDecending = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.RightClickColumn){
                this.SortDescending(this.RightClickColumn.ColumnIndex);
           }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.RightClickSortDecending");
            return ;
        }
    }
    public SetupRangeContextMenu = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            this.CellsContextMenu = new kContextMenu();
            this.CellsContextMenu.AddMenuItem(LNG.COPY,this.CopyClick,kFluentIcons.Copy().ToURLEncoded());
            this.CellsContextMenu.AddMenuItem(LNG.PASTE,this.RightClickPaste,kFluentIcons.Paste().ToURLEncoded());
            this.CellsContextMenu.AddMenuItem(LNG.FILLDOWN,this.FillDown, kEditTableFillIcons.FillDown);
            this.CellsContextMenu.AddMenuItem(LNG.FILLRIGHT,this.FillRight,kEditTableFillIcons.FillRight);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.SetupCellContextMenu");
            return ;
        }
    }
    public _UpdateFillMenuVisibility = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (!this.CellsContextMenu) { return; }
            const MultiRow: boolean = this.Selection.RowIndexEnd > this.Selection.RowIndexStart;
            const MultiCol: boolean = this.Selection.ColIndexEnd > this.Selection.ColindexStart;
            for (const Item of this.CellsContextMenu.MenuItems.Items) {
                if (Item.Title === LNG.FILLDOWN) {
                    Item.DivItem.style.display = MultiRow ? "" : "none";
                } else if (Item.Title === LNG.FILLRIGHT) {
                    Item.DivItem.style.display = MultiCol ? "" : "none";
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._UpdateFillMenuVisibility");
        }
    }
    public FillDown = ():void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            let RowCounter:number = 0;
            let CellInRowCounter:number = 0;
            for(RowCounter=this.Selection.RowIndexStart;RowCounter<=this.Selection.RowIndexEnd;RowCounter ++){
                if(RowCounter>this.Selection.RowIndexStart){
                    const _FillDRow = this.Rows.Items[RowCounter];
                    if (_FillDRow && _FillDRow.ReadOnly) { continue; }
                    for(CellInRowCounter = this.Selection.ColindexStart;CellInRowCounter<=this.Selection.ColIndexEnd;CellInRowCounter++){
                        let CurrTarget:kEditableTableCell = this.GetCellByIndexes(RowCounter,CellInRowCounter);
                        if(CurrTarget.ColDef && CurrTarget.ColDef.Locked===false){
                            let CurrSource:kEditableTableCell = this.GetCellByIndexes(this.Selection.RowIndexStart,CellInRowCounter);
                            CurrTarget.SetNewValue(CurrSource.CurrentValue);
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.FillDown");
            return ;
        }
    }
    public FillRight = ():void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            let RowCounter:number = 0;
            let ColCounter:number = 0;
            for(RowCounter=this.Selection.RowIndexStart;RowCounter<=this.Selection.RowIndexEnd;RowCounter ++){
                const _FillRRow = this.Rows.Items[RowCounter];
                if (_FillRRow && _FillRRow.ReadOnly) { continue; }
                for(ColCounter = this.Selection.ColindexStart;ColCounter<=this.Selection.ColIndexEnd;ColCounter++){
                    if(ColCounter>this.Selection.ColindexStart){
                        let CurrTarget:kEditableTableCell = this.GetCellByIndexes(RowCounter,ColCounter);
                        if(CurrTarget.ColDef && CurrTarget.ColDef.Locked===false){
                            let CurrSource:kEditableTableCell = this.GetCellByIndexes(RowCounter,this.Selection.ColindexStart);
                            CurrTarget.SetNewValue(CurrSource.CurrentValue);
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.FillRight");
            return ;
        }
    }
    public CopyClick = async (): Promise<void> => {
        if (ks.kErrorMode === true) { return ; }
        try {
            const CurrText:string = this.Selection.GetSelectedText();
            ks.copyToClipboard(CurrText);
            ks.ShowNotification(CurrText);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.CopyClick");
            return ;
        }
    }

    public GetClipboardData = async (): Promise<string> => {
        if (ks.kErrorMode === true) { return ""; }
        try {
            return await (navigator as any).clipboard.getData('Text');
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.GetClipboardData");
            return "";
        }
    }

    public RemoveRow = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {

            if(this.RightClickRow && this.RightClickRow.Row){
                if (this.RightClickRow.ReadOnly) { return; }
                this.RightClickRow.Remove(undefined);
                this.UpdateRowNumbers();
            }else{

                let CurrRow:kEditableTableRow;
                let CurrCell:kEditableTableCell;
                let RowIndex:number = 0;

                for(CurrRow of this.Rows.Items){
                    if(CurrRow.Row){
                        for(CurrCell of CurrRow.Cells){
                            if(CurrCell.Cell.classList.contains("SelectedCellSingle") || CurrCell.Cell.classList.contains("SelectedCellMulti")){
                                if(this.RowDeletedCB){
                                    this.RowDeletedCB(CurrRow);
                                }
                                CurrRow.Row.remove();
                                this.Rows.Items.splice(RowIndex,1);
                                break;
                            }
                        }
                    }
                    RowIndex++;
                }
                RowIndex = 0;
                for(CurrRow of this.Rows.Items){
                    CurrRow.Index = RowIndex;
                    if(CurrRow.RowNumberCell){
                        CurrRow.RowNumberCell.textContent = (RowIndex +1).toString();
                        for(CurrCell of CurrRow.Cells){
                            CurrCell.RowIndex = RowIndex;
                        } 
                    }
                    RowIndex++;
                }
            }

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.RemoveRow");
            return ;
        }
    }
    private _RowsToBeDeleted :kEditableTableRows|null = null;
    private _RowCounter:number = 0;
    private _RowBeingDeleted:kEditableTableRow|null = null;
    public RemoveRowContextMenuClick = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            let RowIndexCounter:number = 0;
            for(RowIndexCounter = this.Selection.RowIndexEnd;RowIndexCounter >=this.Selection.RowIndexStart;RowIndexCounter --){
                const CurrRow:kEditableTableRow = this.Rows.Items[RowIndexCounter];
                if (CurrRow.ReadOnly) { continue; }
                CurrRow.Remove(undefined);
            }
            if(this.Rows.Items.length === 0){
                this.AddEmptyRows(1);
            }
            this.UpdateRowNumbers();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable.RemoveRowContextMenuClick");
            return ;
        }
    }
    private _RemoveNextRow = (): void => {

        if (ks.kErrorMode === true) { return ; }
        try {
            if(this._RowsToBeDeleted){
                this._RowBeingDeleted = this._RowsToBeDeleted.Items[this._RowCounter];
                if(this._RowBeingDeleted){
                    this._RowBeingDeleted.Remove(this._AfterRemoveConfirmation);
                }

            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._RemoveNextRow");
            return ;
        }
    }
   
    private _AfterRemoveConfirmation = (): void => {
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this._RowBeingDeleted){
                this._RowBeingDeleted.FadeOut(this._RowBeingDeleted.RemoveAfterFadeOut);
                this._RowCounter++;
                this._RemoveNextRow();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kEditableTable._AfterRemoveConfirmation");
            return ;
        }
    }
}

export class kEditTableFillIcons{
    public static FillDown:string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAAiklEQVQ4T+3SPRIBQRRF4U9O+Sk9SkJExo4tQKpsgggpeyHpKT2PwIgETlUnfe+50ePJAhsMir9IP3eWMehghzvOSLGAMU65s89Og1mW342U8gXzImuQwkgP3SBXUYqUI0cc2sg15UhruSbhits3cs00v49YYYtJDAqq3FnH4H8Hr/zOHQwxip8lDyeqOqpjI20SAAAAAElFTkSuQmCC";
    public static FillRight:string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAAhklEQVQ4T83SMRIBMRiG4WcdQMWuBhWdPbXG6FxCa7UOs5owkdnJr+OrMnneSRX+YTuc0JWQdgjcESMGLAtrcKk46eWhEm0CJ13Wosj5IooczHFN0QPbwLtZEYzZucnOr5X+0SxwS9EdbY6RVzHytoZYB/7+SFOYf6QpB3ucsSohrQ/8x3sCxEw3JKoNdYEAAAAASUVORK5CYII=";
}